import {PassportAccessToken} from "@/js/components/accessTokens/TtrAccessTokens.vue";
import {PassportClient} from "@/js/components/accessTokens/TtrOAuthClients.vue";
import {OptimizerUsageSeries} from "@/js/components/admin/tracking/TtrOptimizerWeeklyStats.vue";
import {AdminAgentData} from "@/js/components/admin/TtrAdminAgentsList.vue";
import {AdminCompanyData, FeatureInfo} from "@/js/components/admin/TtrAdminCompaniesList.vue";
import {SnapshotTableData, TrackingEventsIndexResponse} from "@/js/components/admin/TtrAdminTracking.vue";
import {AdminUserData} from "@/js/components/admin/TtrAdminUsersList.vue";
import {AdminManualSubscription} from "@/js/components/admin/TtrManualSubscriptionsList.vue";
import {GroupMailboxWithMembers} from "@/js/components/groupMailboxes/TtrEditGroupMailbox.vue";
import {AuditEntry} from "@/js/components/logs/TtrLogsAudits.vue";
import {PossibleAssignee} from "@/js/components/optimizer/optimizer-widget-types";
import {TeamWithMembers} from "@/js/components/teams/TtrEditTeam.vue";
import {axios} from "@/js/http/http";
import {BreakPoint} from "@/js/misc/defaultObjects";
import {AxiosRequestConfig, AxiosResponse} from "axios";

//This file was auto-generated by running `php artisan typescript:generate-routes` command.
//To make changes to the routes or responses, adjust the GenerateTypescriptRoutes command and then re-run.

export const passportToken = (routeParams?: {[x: string]: unknown}, body?: any, config?: AxiosRequestConfig): Promise<AxiosResponse<PassportAccessToken>> => {
  // Controller method: Laravel\Passport\Http\Controllers\AccessTokenController::issueToken
  // URI: oauth/token
  return axios.post(route("passport.token", routeParams), body, config);
};

export const passportAuthorizationsAuthorize = (routeParams?: {[x: string]: unknown}, config?: AxiosRequestConfig): Promise<AxiosResponse<any>> => {
  // Controller method: Laravel\Passport\Http\Controllers\AuthorizationController::authorize
  // URI: oauth/authorize
  return axios.get(route("passport.authorizations.authorize", routeParams), config);
};

export const passportTokenRefresh = (routeParams?: {[x: string]: unknown}, body?: any, config?: AxiosRequestConfig): Promise<AxiosResponse<PassportAccessToken>> => {
  // Controller method: Laravel\Passport\Http\Controllers\TransientTokenController::refresh
  // URI: oauth/token/refresh
  return axios.post(route("passport.token.refresh", routeParams), body, config);
};

export const passportAuthorizationsApprove = (routeParams?: {[x: string]: unknown}, body?: any, config?: AxiosRequestConfig): Promise<AxiosResponse<any>> => {
  // Controller method: Laravel\Passport\Http\Controllers\ApproveAuthorizationController::approve
  // URI: oauth/authorize
  return axios.post(route("passport.authorizations.approve", routeParams), body, config);
};

export const passportAuthorizationsDeny = (routeParams?: {[x: string]: unknown}, config?: AxiosRequestConfig): Promise<AxiosResponse<any>> => {
  // Controller method: Laravel\Passport\Http\Controllers\DenyAuthorizationController::deny
  // URI: oauth/authorize
  return axios.delete(route("passport.authorizations.deny", routeParams), config);
};

export const passportTokensIndex = (routeParams?: {[x: string]: unknown}, config?: AxiosRequestConfig): Promise<AxiosResponse<Array<PassportAccessToken>>> => {
  // Controller method: Laravel\Passport\Http\Controllers\AuthorizedAccessTokenController::forUser
  // URI: oauth/tokens
  return axios.get(route("passport.tokens.index", routeParams), config);
};

export const passportTokensDestroy = (routeParams: {token_id: string | number; [x: string]: unknown}, config?: AxiosRequestConfig): Promise<AxiosResponse<any>> => {
  // Controller method: Laravel\Passport\Http\Controllers\AuthorizedAccessTokenController::destroy
  // URI: oauth/tokens/{token_id}
  return axios.delete(route("passport.tokens.destroy", routeParams), config);
};

export const passportClientsIndex = (routeParams?: {[x: string]: unknown}, config?: AxiosRequestConfig): Promise<AxiosResponse<PassportClient[]>> => {
  // Controller method: Laravel\Passport\Http\Controllers\ClientController::forUser
  // URI: oauth/clients
  return axios.get(route("passport.clients.index", routeParams), config);
};

export const passportClientsStore = (routeParams?: {[x: string]: unknown}, body?: any, config?: AxiosRequestConfig): Promise<AxiosResponse<PassportClient>> => {
  // Controller method: Laravel\Passport\Http\Controllers\ClientController::store
  // URI: oauth/clients
  return axios.post(route("passport.clients.store", routeParams), body, config);
};

export const passportClientsUpdate = (routeParams: {client_id: string | number; [x: string]: unknown}, body: any, config?: AxiosRequestConfig): Promise<AxiosResponse<PassportClient>> => {
  // Controller method: Laravel\Passport\Http\Controllers\ClientController::update
  // URI: oauth/clients/{client_id}
  return axios.put(route("passport.clients.update", routeParams), body, config);
};

export const passportClientsDestroy = (routeParams: {client_id: string | number; [x: string]: unknown}, config?: AxiosRequestConfig): Promise<AxiosResponse<any>> => {
  // Controller method: Laravel\Passport\Http\Controllers\ClientController::destroy
  // URI: oauth/clients/{client_id}
  return axios.delete(route("passport.clients.destroy", routeParams), config);
};

export const passportScopesIndex = (routeParams?: {[x: string]: unknown}, config?: AxiosRequestConfig): Promise<AxiosResponse<any>> => {
  // Controller method: Laravel\Passport\Http\Controllers\ScopeController::all
  // URI: oauth/scopes
  return axios.get(route("passport.scopes.index", routeParams), config);
};

export const passportPersonalTokensIndex = (routeParams?: {[x: string]: unknown}, config?: AxiosRequestConfig): Promise<AxiosResponse<Array<PassportAccessToken>>> => {
  // Controller method: Laravel\Passport\Http\Controllers\PersonalAccessTokenController::forUser
  // URI: oauth/personal-access-tokens
  return axios.get(route("passport.personal.tokens.index", routeParams), config);
};

export const passportPersonalTokensStore = (routeParams?: {[x: string]: unknown}, body?: any, config?: AxiosRequestConfig): Promise<AxiosResponse<{accessToken: string; token: PassportAccessToken}>> => {
  // Controller method: Laravel\Passport\Http\Controllers\PersonalAccessTokenController::store
  // URI: oauth/personal-access-tokens
  return axios.post(route("passport.personal.tokens.store", routeParams), body, config);
};

export const passportPersonalTokensDestroy = (routeParams: {token_id: string | number; [x: string]: unknown}, config?: AxiosRequestConfig): Promise<AxiosResponse<any>> => {
  // Controller method: Laravel\Passport\Http\Controllers\PersonalAccessTokenController::destroy
  // URI: oauth/personal-access-tokens/{token_id}
  return axios.delete(route("passport.personal.tokens.destroy", routeParams), config);
};

export const apiAdminTest = (routeParams?: {[x: string]: unknown}, config?: AxiosRequestConfig): Promise<AxiosResponse<string>> => {
  // Controller method: App\Http\Controllers\Api\Admin\TestController::index
  // URI: api/admin/test
  return axios.get(route("api.admin.test", routeParams), config);
};

export const apiAdminMockApi = (routeParams?: App.Http.Requests.Admin.AdminTestGetMessagesRequest & {[x: string]: unknown}, config?: AxiosRequestConfig): Promise<AxiosResponse<App.DataObjects.PreStoredMessage[]>> => {
  // Controller method: App\Http\Controllers\Api\Admin\TestController::getMessages
  // URI: api/admin/mock-api
  // @ts-ignore the below error is because ziggy does not know about the shape of the query params
  return axios.get(route("api.admin.mock-api", routeParams), config);
};

export const apiExternalHostsIndex = (routeParams?: {[x: string]: unknown}, config?: AxiosRequestConfig): Promise<AxiosResponse<{data: LaravelLengthAwarePaginator<App.Models.ExternalHost>}>> => {
  // Controller method: App\Http\Controllers\Api\Admin\ExternalHostController::index
  // URI: api/admin/external-hosts
  return axios.get(route("api.external-hosts.index", routeParams), config);
};

export const apiAdminB2bSaasReportIndex = (routeParams?: App.Http.Requests.Admin.B2BSaasReportIndexRequest & {[x: string]: unknown}, config?: AxiosRequestConfig): Promise<AxiosResponse<App.DataObjects.B2BSaas.B2BSaasReportData>> => {
  // Controller method: App\Http\Controllers\Api\Admin\B2BSaasReportController::index
  // URI: api/admin/b2b-saas-report
  // @ts-ignore the below error is because ziggy does not know about the shape of the query params
  return axios.get(route("api.admin.b2b-saas-report.index", routeParams), config);
};

export const apiExternalHostsGetHostData = (routeParams?: {[x: string]: unknown}, config?: AxiosRequestConfig): Promise<AxiosResponse<{data: {current_agents_count: number; max_agents_count: number; service_expiry_date: string}}>> => {
  // Controller method: App\Http\Controllers\Api\Admin\ExternalHostController::getHostData
  // URI: api/admin/host-data
  return axios.get(route("api.external-hosts.getHostData", routeParams), config);
};

export const apiExternalHostsSetHostData = (
  routeParams?: {[x: string]: unknown},
  body?: App.Http.Requests.Admin.AdminSetHostDataRequest,
  config?: AxiosRequestConfig,
): Promise<AxiosResponse<{data: {current_agents_count: number; max_agents_count: number; service_expiry_date: string}}>> => {
  // Controller method: App\Http\Controllers\Api\Admin\ExternalHostController::setHostData
  // URI: api/admin/host-data
  return axios.post(route("api.external-hosts.setHostData", routeParams), body, config);
};

export const apiAdminUsersIndex = (routeParams?: App.Http.Requests.Admin.UsersIndexRequest & {[x: string]: unknown}, config?: AxiosRequestConfig): Promise<AxiosResponse<LaravelLengthAwarePaginator<AdminUserData>>> => {
  // Controller method: App\Http\Controllers\Api\Admin\UsersController::index
  // URI: api/admin/users
  // @ts-ignore the below error is because ziggy does not know about the shape of the query params
  return axios.get(route("api.admin.users.index", routeParams), config);
};

export const apiAdminUsersVerify = (routeParams: {user: string | number; [x: string]: unknown}, body: any, config?: AxiosRequestConfig): Promise<AxiosResponse<App.DataObjects.TtrStatusResponse>> => {
  // Controller method: App\Http\Controllers\Api\Admin\UsersController::verifyEmail
  // URI: api/admin/users/{user}/verify-email
  return axios.patch(route("api.admin.users.verify", routeParams), body, config);
};

export const apiAdminUsersToggleProductType = (routeParams: {user: string | number; [x: string]: unknown}, body: any, config?: AxiosRequestConfig): Promise<AxiosResponse<string>> => {
  // Controller method: App\Http\Controllers\Api\Admin\UsersController::toggleProductType
  // URI: api/admin/users/{user}/toggle-product-type
  return axios.patch(route("api.admin.users.toggle-product-type", routeParams), body, config);
};

export const apiAdminUsersDestroy = (routeParams: {user: string | number; [x: string]: unknown}, config?: AxiosRequestConfig): Promise<AxiosResponse<App.DataObjects.TtrStatusResponse>> => {
  // Controller method: App\Http\Controllers\Api\Admin\UsersController::destroy
  // URI: api/admin/users/{user}
  return axios.delete(route("api.admin.users.destroy", routeParams), config);
};

export const apiAdminAgentsIndex = (routeParams?: App.Http.Requests.Admin.AdminAgentsIndexRequest & {[x: string]: unknown}, config?: AxiosRequestConfig): Promise<AxiosResponse<LaravelLengthAwarePaginator<AdminAgentData>>> => {
  // Controller method: App\Http\Controllers\Api\Admin\AgentsController::index
  // URI: api/admin/agents
  // @ts-ignore the below error is because ziggy does not know about the shape of the query params
  return axios.get(route("api.admin.agents.index", routeParams), config);
};

export const apiAdminExtendTrial = (
  routeParams: {company: string | number; [x: string]: unknown},
  body: App.Http.Requests.Admin.CompaniesExtendTrialRequest,
  config?: AxiosRequestConfig,
): Promise<AxiosResponse<App.DataObjects.TtrStatusResponse & {newDate: string}>> => {
  // Controller method: App\Http\Controllers\Api\Admin\CompaniesController::extendTrial
  // URI: api/admin/companies/{company}/extend-trial
  return axios.patch(route("api.admin.extend.trial", routeParams), body, config);
};

export const apiAdminSetTrialLimit = (
  routeParams: {company: string | number; [x: string]: unknown},
  body: App.Http.Requests.Admin.CompaniesSetTrialLimitRequest,
  config?: AxiosRequestConfig,
): Promise<AxiosResponse<App.DataObjects.TtrStatusResponse>> => {
  // Controller method: App\Http\Controllers\Api\Admin\CompaniesController::setTrialLimit
  // URI: api/admin/companies/{company}/set-trial-limit
  return axios.patch(route("api.admin.set.trial.limit", routeParams), body, config);
};

export const apiAdminCompaniesSetProfitwellCode = (
  routeParams: {company: string | number; [x: string]: unknown},
  body: App.Http.Requests.Admin.SetProfitwellCodeRequest,
  config?: AxiosRequestConfig,
): Promise<AxiosResponse<App.DataObjects.TtrStatusResponse>> => {
  // Controller method: App\Http\Controllers\Api\Admin\CompaniesController::setProfitwellCode
  // URI: api/admin/companies/{company}/set-profitwell-code
  return axios.patch(route("api.admin.companies.set-profitwell-code", routeParams), body, config);
};

export const apiAdminCompaniesSetPrimaryAdmin = (
  routeParams: {company: string | number; [x: string]: unknown},
  body: App.Http.Requests.Admin.SetPrimaryAdminRequest,
  config?: AxiosRequestConfig,
): Promise<AxiosResponse<App.DataObjects.TtrStatusResponse>> => {
  // Controller method: App\Http\Controllers\Api\Admin\CompaniesController::setPrimaryAdmin
  // URI: api/admin/companies/{company}/set-primary-admin
  return axios.patch(route("api.admin.companies.set-primary-admin", routeParams), body, config);
};

export const apiAdminCompaniesUpdateBlock = (
  routeParams: {company: string | number; [x: string]: unknown},
  body: App.Http.Requests.Admin.AdminUpdateBlockRequest,
  config?: AxiosRequestConfig,
): Promise<AxiosResponse<App.DataObjects.TtrStatusResponse>> => {
  // Controller method: App\Http\Controllers\Api\Admin\CompaniesController::updateBlock
  // URI: api/admin/companies/{company}/update-block
  return axios.patch(route("api.admin.companies.update-block", routeParams), body, config);
};

export const apiAdminCompaniesMakeReseller = (
  routeParams: {company: string | number; [x: string]: unknown},
  body: App.Http.Requests.Admin.AdminMakeResellerRequest,
  config?: AxiosRequestConfig,
): Promise<AxiosResponse<App.DataObjects.TtrStatusResponse>> => {
  // Controller method: App\Http\Controllers\Api\Admin\CompaniesController::makeReseller
  // URI: api/admin/companies/{company}/make-reseller
  return axios.patch(route("api.admin.companies.make.reseller", routeParams), body, config);
};

export const apiAdminCompaniesGetFeatures = (routeParams: {company: string | number; [x: string]: unknown}, config?: AxiosRequestConfig): Promise<AxiosResponse<Record<string, FeatureInfo>>> => {
  // Controller method: App\Http\Controllers\Api\Admin\CompaniesController::getFeatures
  // URI: api/admin/companies/{company}/features
  return axios.get(route("api.admin.companies.get-features", routeParams), config);
};

export const apiAdminCompaniesSetFeatures = (
  routeParams: {company: string | number; [x: string]: unknown},
  body: App.Http.Requests.Admin.AdminSetFeaturesRequest,
  config?: AxiosRequestConfig,
): Promise<AxiosResponse<App.DataObjects.TtrStatusResponse>> => {
  // Controller method: App\Http\Controllers\Api\Admin\CompaniesController::setFeatures
  // URI: api/admin/companies/{company}/features
  return axios.patch(route("api.admin.companies.set-features", routeParams), body, config);
};

export const apiAdminCompaniesIndex = (routeParams?: App.Http.Requests.Admin.AdminCompaniesIndexRequest & {[x: string]: unknown}, config?: AxiosRequestConfig): Promise<AxiosResponse<LaravelLengthAwarePaginator<AdminCompanyData>>> => {
  // Controller method: App\Http\Controllers\Api\Admin\CompaniesController::index
  // URI: api/admin/companies
  // @ts-ignore the below error is because ziggy does not know about the shape of the query params
  return axios.get(route("api.admin.companies.index", routeParams), config);
};

export const apiAdminResellersIndex = (
  routeParams?: App.Http.Requests.Admin.AdminGetResellersRequest & {[x: string]: unknown},
  config?: AxiosRequestConfig,
): Promise<AxiosResponse<LaravelLengthAwarePaginator<App.DataObjects.ElasticsearchEntityObject>>> => {
  // Controller method: App\Http\Controllers\Api\Admin\CompaniesController::getResellers
  // URI: api/admin/resellers
  // @ts-ignore the below error is because ziggy does not know about the shape of the query params
  return axios.get(route("api.admin.resellers.index", routeParams), config);
};

export const apiAdminResellerAssignCompany = (
  routeParams: {reseller: string | number; company: string | number; [x: string]: unknown},
  body: App.Http.Requests.Admin.AdminAssignCompanyRequest,
  config?: AxiosRequestConfig,
): Promise<AxiosResponse<App.DataObjects.TtrStatusResponse>> => {
  // Controller method: App\Http\Controllers\Api\Admin\CompaniesController::assignCompany
  // URI: api/admin/resellers/{reseller}/assign-company/{company}
  return axios.patch(route("api.admin.reseller.assign.company", routeParams), body, config);
};

export const apiAdminResellerSetSlackChannel = (
  routeParams: {reseller: string | number; [x: string]: unknown},
  body: App.Http.Requests.Admin.AdminSetSlackChannelRequest,
  config?: AxiosRequestConfig,
): Promise<AxiosResponse<App.DataObjects.TtrStatusResponse>> => {
  // Controller method: App\Http\Controllers\Api\Admin\CompaniesController::setSlackChannel
  // URI: api/admin/resellers/{reseller}/set-slack-channel
  return axios.post(route("api.admin.reseller.set.slack.channel", routeParams), body, config);
};

export const apiAdminTrackingEventsIndex = (routeParams?: App.Http.Requests.Admin.TrackingEventIndexRequest & {[x: string]: unknown}, config?: AxiosRequestConfig): Promise<AxiosResponse<TrackingEventsIndexResponse>> => {
  // Controller method: App\Http\Controllers\Api\Admin\TrackingEventController::index
  // URI: api/admin/tracking-events
  // @ts-ignore the below error is because ziggy does not know about the shape of the query params
  return axios.get(route("api.admin.tracking-events.index", routeParams), config);
};

export const apiAdminOptimizerAnalyticsTrend = (
  routeParams?: App.Http.Requests.Admin.AdminOptimizerAnalyticsTrendRequest & {[x: string]: unknown},
  config?: AxiosRequestConfig,
): Promise<
  AxiosResponse<{
    microsoft: {
      xData: string[];
      series: OptimizerUsageSeries;
    };
    gmail: {
      xData: string[];
      series: OptimizerUsageSeries;
    };
    chrome: {
      xData: string[];
      series: OptimizerUsageSeries;
    };
  }>
> => {
  // Controller method: App\Http\Controllers\Api\Admin\OptimizerAnalyticsController::trend
  // URI: api/admin/optimizer-analytics/trend
  // @ts-ignore the below error is because ziggy does not know about the shape of the query params
  return axios.get(route("api.admin.optimizer-analytics.trend", routeParams), config);
};

export const apiAdminOptimizerAnalyticsAgentUsage = (
  routeParams?: App.Http.Requests.Admin.AdminOptimizerAnalyticsAgentUsageRequest & {[x: string]: unknown},
  config?: AxiosRequestConfig,
): Promise<
  AxiosResponse<{
    optimizerAgentUsage: LaravelLengthAwarePaginator<{
      id: number;
      name: string;
      mail_email: string;
      company_id: number;
      company_name: string;
      type: string;
      type_id: number;
      last_used: string;
      frequency: number;
      is_active: boolean;
      version: string;
    }>;
  }>
> => {
  // Controller method: App\Http\Controllers\Api\Admin\OptimizerAnalyticsController::agentUsage
  // URI: api/admin/optimizer-analytics/agent-usage
  // @ts-ignore the below error is because ziggy does not know about the shape of the query params
  return axios.get(route("api.admin.optimizer-analytics.agent-usage", routeParams), config);
};

export const apiAdminOptimizerAnalyticsCompanyUsage = (
  routeParams?: App.Http.Requests.Admin.AdminOptimizerAnalyticsCompanyUsageRequest & {[x: string]: unknown},
  config?: AxiosRequestConfig,
): Promise<
  AxiosResponse<{
    optimizerCompanyUsage: LaravelLengthAwarePaginator<{
      id: number;
      name: string;
      types: string[];
      type_ids: number[];
      last_used: string;
      avg_frequency: number;
      is_active: boolean;
      active_percentage: number;
      total_agents: number;
      installed_agents: number;
      active_agents: number;
      currently_installed_agents: number;
    }>;
  }>
> => {
  // Controller method: App\Http\Controllers\Api\Admin\OptimizerAnalyticsController::companyUsage
  // URI: api/admin/optimizer-analytics/company-usage
  // @ts-ignore the below error is because ziggy does not know about the shape of the query params
  return axios.get(route("api.admin.optimizer-analytics.company-usage", routeParams), config);
};

export const apiAdminOptimizerAnalyticsSnapshots = (routeParams?: App.Http.Requests.Admin.AdminOptimizerAnalyticsSnapshotsRequest & {[x: string]: unknown}, config?: AxiosRequestConfig): Promise<AxiosResponse<SnapshotTableData>> => {
  // Controller method: App\Http\Controllers\Api\Admin\OptimizerAnalyticsController::snapshots
  // URI: api/admin/optimizer-analytics/snapshots
  // @ts-ignore the below error is because ziggy does not know about the shape of the query params
  return axios.get(route("api.admin.optimizer-analytics.snapshots", routeParams), config);
};

export const apiAdminManualSubscriptionsIndex = (
  routeParams?: App.Http.Requests.Admin.ManualSubscriptionIndexRequest & {[x: string]: unknown},
  config?: AxiosRequestConfig,
): Promise<AxiosResponse<LaravelLengthAwarePaginator<AdminManualSubscription>>> => {
  // Controller method: App\Http\Controllers\Api\Admin\ManualSubscriptionController::index
  // URI: api/admin/manual-subscriptions
  // @ts-ignore the below error is because ziggy does not know about the shape of the query params
  return axios.get(route("api.admin.manual-subscriptions.index", routeParams), config);
};

export const apiAdminManualSubscriptionsStore = (
  routeParams?: {[x: string]: unknown},
  body?: App.Http.Requests.Admin.AdminStoreManualSubscriptionRequest,
  config?: AxiosRequestConfig,
): Promise<AxiosResponse<App.Models.ManualSubscription>> => {
  // Controller method: App\Http\Controllers\Api\Admin\ManualSubscriptionController::store
  // URI: api/admin/manual-subscriptions
  return axios.post(route("api.admin.manual-subscriptions.store", routeParams), body, config);
};

export const apiAdminManualSubscriptionsShow = (routeParams: {manual_subscription: string | number; [x: string]: unknown}, config?: AxiosRequestConfig): Promise<AxiosResponse<App.Models.ManualSubscription>> => {
  // Controller method: App\Http\Controllers\Api\Admin\ManualSubscriptionController::show
  // URI: api/admin/manual-subscriptions/{manual_subscription}
  return axios.get(route("api.admin.manual-subscriptions.show", routeParams), config);
};

export const apiAdminManualSubscriptionsUpdate = (
  routeParams: {manual_subscription: string | number; [x: string]: unknown},
  body: App.Http.Requests.Admin.AdminStoreManualSubscriptionRequest,
  config?: AxiosRequestConfig,
): Promise<AxiosResponse<App.Models.ManualSubscription>> => {
  // Controller method: App\Http\Controllers\Api\Admin\ManualSubscriptionController::update
  // URI: api/admin/manual-subscriptions/{manual_subscription}
  return axios.put(route("api.admin.manual-subscriptions.update", routeParams), body, config);
};

export const apiAdminManualSubscriptionsDestroy = (routeParams: {manual_subscription: string | number; [x: string]: unknown}, config?: AxiosRequestConfig): Promise<AxiosResponse<App.DataObjects.TtrStatusResponse>> => {
  // Controller method: App\Http\Controllers\Api\Admin\ManualSubscriptionController::destroy
  // URI: api/admin/manual-subscriptions/{manual_subscription}
  return axios.delete(route("api.admin.manual-subscriptions.destroy", routeParams), config);
};

export const apiPromotionsStore = (routeParams?: {[x: string]: unknown}, body?: App.Http.Requests.Admin.PromotionRequest, config?: AxiosRequestConfig): Promise<AxiosResponse<string>> => {
  // Controller method: App\Http\Controllers\Api\Admin\PromotionController::store
  // URI: api/admin/promotions
  return axios.postForm(route("api.promotions.store", routeParams), body, config);
};

export const apiPromotionsUpdate = (routeParams: {promotion: string | number; [x: string]: unknown}, body: App.Http.Requests.Admin.PromotionRequest, config?: AxiosRequestConfig): Promise<AxiosResponse<string>> => {
  // Controller method: App\Http\Controllers\Api\Admin\PromotionController::update
  // URI: api/admin/promotions/{promotion}
  // @ts-ignore
  body._method = "PATCH";
  return axios.postForm(route("api.promotions.update", routeParams), body, config);
};

export const apiResellerUsersIndex = (routeParams?: App.Http.Requests.Admin.UsersIndexRequest & {[x: string]: unknown}, config?: AxiosRequestConfig): Promise<AxiosResponse<LaravelLengthAwarePaginator<AdminUserData>>> => {
  // Controller method: App\Http\Controllers\Api\Admin\UsersController::index
  // URI: api/reseller/users
  // @ts-ignore the below error is because ziggy does not know about the shape of the query params
  return axios.get(route("api.reseller.users.index", routeParams), config);
};

export const apiResellerAgentsIndex = (routeParams?: App.Http.Requests.Admin.AdminAgentsIndexRequest & {[x: string]: unknown}, config?: AxiosRequestConfig): Promise<AxiosResponse<LaravelLengthAwarePaginator<AdminAgentData>>> => {
  // Controller method: App\Http\Controllers\Api\Admin\AgentsController::index
  // URI: api/reseller/agents
  // @ts-ignore the below error is because ziggy does not know about the shape of the query params
  return axios.get(route("api.reseller.agents.index", routeParams), config);
};

export const apiResellerCompaniesIndex = (routeParams?: App.Http.Requests.Admin.AdminCompaniesIndexRequest & {[x: string]: unknown}, config?: AxiosRequestConfig): Promise<AxiosResponse<LaravelLengthAwarePaginator<AdminCompanyData>>> => {
  // Controller method: App\Http\Controllers\Api\Admin\CompaniesController::index
  // URI: api/reseller/companies
  // @ts-ignore the below error is because ziggy does not know about the shape of the query params
  return axios.get(route("api.reseller.companies.index", routeParams), config);
};

export const apiSignedThreadsCloseMulti = (routeParams?: {[x: string]: unknown}, body?: App.Http.Requests.Logs.ConversationLogSignedCloseMultiRequest, config?: AxiosRequestConfig): Promise<AxiosResponse<{ids: number[]}>> => {
  // Controller method: App\Http\Controllers\Api\Logs\ConversationLogController::signedCloseMulti
  // URI: api/threads/close
  return axios.post(route("api.signed.threads.close-multi", routeParams), body, config);
};

export const apiSignedThreadsSnoozeMulti = (routeParams?: {[x: string]: unknown}, body?: App.Http.Requests.Logs.ConversationLogSignedSnoozeMultiRequest, config?: AxiosRequestConfig): Promise<AxiosResponse<{ids: number[]}>> => {
  // Controller method: App\Http\Controllers\Api\Logs\ConversationLogController::signedSnoozeMulti
  // URI: api/threads/snooze
  return axios.post(route("api.signed.threads.snooze-multi", routeParams), body, config);
};

export const apiCompanyEntitiesSearch = (
  routeParams?: App.Http.Requests.Tools.CompanySearchEntitiesRequest & {[x: string]: unknown},
  config?: AxiosRequestConfig,
): Promise<AxiosResponse<LaravelLengthAwarePaginator<App.DataObjects.ElasticsearchEntityObject> | {id: number; name: string; email: string | null; type: number}[]>> => {
  // Controller method: App\Http\Controllers\Api\Tools\CompanyController::searchEntities
  // URI: api/entities/search
  // @ts-ignore the below error is because ziggy does not know about the shape of the query params
  return axios.get(route("api.company.entities.search", routeParams), config);
};

export const apiAgentsIndex = (routeParams?: App.Http.Requests.Entities.AgentsIndexRequest & {[x: string]: unknown}, config?: AxiosRequestConfig): Promise<AxiosResponse<LaravelLengthAwarePaginator<App.Models.Agent>>> => {
  // Controller method: App\Http\Controllers\Api\Entities\AgentsController::index
  // URI: api/entities/agents
  // @ts-ignore the below error is because ziggy does not know about the shape of the query params
  return axios.get(route("api.agents.index", routeParams), config);
};

export const apiAgentsStore = (
  routeParams?: {[x: string]: unknown},
  body?: App.Http.Requests.Entities.AgentInvitesStoreRequest,
  config?: AxiosRequestConfig,
): Promise<AxiosResponse<{exists: boolean} | {success: boolean; authURL: string; id: number}>> => {
  // Controller method: App\Http\Controllers\Api\Entities\AgentInvitesController::store
  // URI: api/entities/agents/invite
  return axios.post(route("api.agents.store", routeParams), body, config);
};

export const apiAgentsRemind = (routeParams: {authentication_invite: string | number; [x: string]: unknown}, body: any, config?: AxiosRequestConfig): Promise<AxiosResponse<App.DataObjects.TtrStatusResponse>> => {
  // Controller method: App\Http\Controllers\Api\Entities\AgentInvitesController::remind
  // URI: api/entities/agents/remind/{authentication_invite}
  return axios.patch(route("api.agents.remind", routeParams), body, config);
};

export const apiAgentsInviteDestroy = (routeParams: {authentication_invite: string | number; [x: string]: unknown}, config?: AxiosRequestConfig): Promise<AxiosResponse<App.DataObjects.TtrStatusResponse>> => {
  // Controller method: App\Http\Controllers\Api\Entities\AgentInvitesController::destroy
  // URI: api/entities/agents/invite/{authentication_invite}
  return axios.delete(route("api.agents.invite.destroy", routeParams), config);
};

export const apiAgentsItHelp = (routeParams?: {[x: string]: unknown}, body?: App.Http.Requests.Entities.AgentsItHelpRequest, config?: AxiosRequestConfig): Promise<AxiosResponse<App.DataObjects.TtrStatusResponse>> => {
  // Controller method: App\Http\Controllers\Api\Entities\AgentsController::itHelp
  // URI: api/entities/agents/it-help
  return axios.post(route("api.agents.it-help", routeParams), body, config);
};

export const apiMimecastForceSyncAgents = (routeParams?: {[x: string]: unknown}, body?: any, config?: AxiosRequestConfig): Promise<AxiosResponse<App.DataObjects.TtrStatusResponse>> => {
  // Controller method: App\Http\Controllers\Api\Entities\AgentsController::forceSyncAgentsMimecast
  // URI: api/entities/agents/mimecast/force-sync-agents
  return axios.post(route("api.mimecast.force.sync.agents", routeParams), body, config);
};

export const apiMimecastGenerateToken = (
  routeParams?: {[x: string]: unknown},
  body?: App.Http.Requests.Auth.oAuth.MimecastAuthGenerateTokenRequest,
  config?: AxiosRequestConfig,
): Promise<AxiosResponse<App.DataObjects.TtrStatusResponse>> => {
  // Controller method: App\Http\Controllers\Api\Auth\oAuth\MimecastAuthController::generateToken
  // URI: api/entities/agents/mimecast/auth
  return axios.post(route("api.mimecast.generate.token", routeParams), body, config);
};

export const apiMimecastLoadBulk = (routeParams?: {[x: string]: unknown}, config?: AxiosRequestConfig): Promise<AxiosResponse<{users: {email: string}[]; end: boolean; slow: boolean}>> => {
  // Controller method: App\Http\Controllers\Api\Entities\AgentsController::mimecastLoadBulkAddAgents
  // URI: api/entities/agents/mimecast/load-bulk-agents
  return axios.get(route("api.mimecast.load.bulk", routeParams), config);
};

export const apiMimecastSearchAgents = (routeParams?: {[x: string]: unknown}, body?: App.Http.Requests.Entities.AgentsSearchAgentsMimecastRequest, config?: AxiosRequestConfig): Promise<AxiosResponse<{agents: string[]}>> => {
  // Controller method: App\Http\Controllers\Api\Entities\AgentsController::searchAgentsMimecast
  // URI: api/entities/agents/mimecast/search-agents
  return axios.post(route("api.mimecast.search.agents", routeParams), body, config);
};

export const apiMimecastSaveBulk = (routeParams?: {[x: string]: unknown}, body?: App.Http.Requests.Auth.oAuth.MimecastAuthStoreBulkRequest, config?: AxiosRequestConfig): Promise<AxiosResponse<string[]>> => {
  // Controller method: App\Http\Controllers\Api\Auth\oAuth\MimecastAuthController::storeBulk
  // URI: api/entities/agents/mimecast/select-bulk
  return axios.post(route("api.mimecast.save.bulk", routeParams), body, config);
};

export const apiMsgraphLoadBulk = (
  routeParams?: App.Http.Requests.Entities.AgentsMsGraphLoadBulkAddAgentsRequest & {[x: string]: unknown},
  config?: AxiosRequestConfig,
): Promise<AxiosResponse<{users: {api_id: string; name: string; email: string; email_usernames: string[]; is_real_group: boolean; userPrincipalName: string}[]; nextPageToken: string}>> => {
  // Controller method: App\Http\Controllers\Api\Entities\AgentsController::msGraphLoadBulkAddAgents
  // URI: api/entities/agents/microsoft/load-bulk-agents
  // @ts-ignore the below error is because ziggy does not know about the shape of the query params
  return axios.get(route("api.msgraph.load.bulk", routeParams), config);
};

export const apiMsgraphSearchBulk = (
  routeParams?: App.Http.Requests.Entities.AgentsMsGraphSearchGroupMailboxesRequest & {[x: string]: unknown},
  config?: AxiosRequestConfig,
): Promise<AxiosResponse<{api_id?: string; id?: number; name: string; email?: string; email_usernames: string[]; is_real_group?: boolean; userPrincipalName?: string}[]>> => {
  // Controller method: App\Http\Controllers\Api\Entities\AgentsController::msGraphSearchBulkAddAgents
  // URI: api/entities/agents/microsoft/search-bulk-agents
  // @ts-ignore the below error is because ziggy does not know about the shape of the query params
  return axios.get(route("api.msgraph.search.bulk", routeParams), config);
};

export const apiMsgraphSearchGroups = (
  routeParams?: App.Http.Requests.Entities.AgentsMsGraphSearchGroupMailboxesRequest & {[x: string]: unknown},
  config?: AxiosRequestConfig,
): Promise<AxiosResponse<{api_id?: string; id?: number; name: string; email?: string; email_usernames: string[]; is_real_group?: boolean; userPrincipalName?: string}[]>> => {
  // Controller method: App\Http\Controllers\Api\Entities\AgentsController::msGraphSearchGroupMailboxes
  // URI: api/entities/agents/microsoft/search-groups
  // @ts-ignore the below error is because ziggy does not know about the shape of the query params
  return axios.get(route("api.msgraph.search.groups", routeParams), config);
};

export const apiMsgraphGroupsMembers = (
  routeParams?: App.Http.Requests.Entities.AgentsMsGraphGroupMailboxMembersRequest & {[x: string]: unknown},
  config?: AxiosRequestConfig,
): Promise<AxiosResponse<{members: {api_id?: string; id?: number; name: string; email?: string; email_usernames: string[]; is_real_group?: boolean; userPrincipalName?: string}[]; nextPageToken: string; id: number}>> => {
  // Controller method: App\Http\Controllers\Api\Entities\AgentsController::msGraphGroupMailboxMembers
  // URI: api/entities/agents/microsoft/group-members
  // @ts-ignore the below error is because ziggy does not know about the shape of the query params
  return axios.get(route("api.msgraph.groups.members", routeParams), config);
};

export const apiMsgraphSaveBulk = (
  routeParams?: {[x: string]: unknown},
  body?: App.Http.Requests.Auth.oAuth.MsGraphAuthStoreBulkRequest,
  config?: AxiosRequestConfig,
): Promise<AxiosResponse<number | {success: string[]; fail: string[]}>> => {
  // Controller method: App\Http\Controllers\Api\Auth\oAuth\MsGraphAuthController::storeBulk
  // URI: api/entities/agents/microsoft/select-bulk
  return axios.postForm(route("api.msgraph.save.bulk", routeParams), body, config);
};

export const apiGmailLoadBulk = (
  routeParams?: App.Http.Requests.Entities.AgentsGmailLoadBulkAddAgentsRequest & {[x: string]: unknown},
  config?: AxiosRequestConfig,
): Promise<AxiosResponse<{users: {api_id: string; name: string; email: string; email_usernames: string[]; is_real_group: boolean}[]; nextPageToken: string}>> => {
  // Controller method: App\Http\Controllers\Api\Entities\AgentsController::gmailLoadBulkAddAgents
  // URI: api/entities/agents/gmail/load-bulk-agents
  // @ts-ignore the below error is because ziggy does not know about the shape of the query params
  return axios.get(route("api.gmail.load.bulk", routeParams), config);
};

export const apiGmailSearchBulk = (
  routeParams?: App.Http.Requests.Entities.AgentsGmailSearchBulkAddAgentsRequest & {[x: string]: unknown},
  config?: AxiosRequestConfig,
): Promise<AxiosResponse<{api_id?: string; id?: number; name: string; email?: string; email_usernames: string[]; is_real_group?: boolean; userPrincipalName?: string}[]>> => {
  // Controller method: App\Http\Controllers\Api\Entities\AgentsController::gmailSearchBulkAddAgents
  // URI: api/entities/agents/gmail/search-agents
  // @ts-ignore the below error is because ziggy does not know about the shape of the query params
  return axios.get(route("api.gmail.search.bulk", routeParams), config);
};

export const apiGmailSearchGroups = (
  routeParams?: App.Http.Requests.Entities.AgentsGmailSearchGroupMailboxesRequest & {[x: string]: unknown},
  config?: AxiosRequestConfig,
): Promise<AxiosResponse<{api_id?: string; id?: number; name: string; email?: string; email_usernames: string[]; is_real_group?: boolean; userPrincipalName?: string}[]>> => {
  // Controller method: App\Http\Controllers\Api\Entities\AgentsController::gmailSearchGroupMailboxes
  // URI: api/entities/agents/gmail/search-groups
  // @ts-ignore the below error is because ziggy does not know about the shape of the query params
  return axios.get(route("api.gmail.search.groups", routeParams), config);
};

export const apiGmailGroupsMembers = (
  routeParams?: App.Http.Requests.Entities.AgentsGmailGroupMailboxMembersRequest & {[x: string]: unknown},
  config?: AxiosRequestConfig,
): Promise<AxiosResponse<{members: {id: string; email: string}[]; nextPageToken: string; id: number}>> => {
  // Controller method: App\Http\Controllers\Api\Entities\AgentsController::gmailGroupMailboxMembers
  // URI: api/entities/agents/gmail/group-members
  // @ts-ignore the below error is because ziggy does not know about the shape of the query params
  return axios.get(route("api.gmail.groups.members", routeParams), config);
};

export const apiGmailSaveBulk = (routeParams?: {[x: string]: unknown}, body?: App.Http.Requests.Auth.oAuth.GoogleAuthStoreBulkRequest, config?: AxiosRequestConfig): Promise<AxiosResponse<{success: string[]; fail: string[]}>> => {
  // Controller method: App\Http\Controllers\Api\Auth\oAuth\GoogleAuthController::storeBulk
  // URI: api/entities/agents/gmail/select-bulk
  return axios.post(route("api.gmail.save.bulk", routeParams), body, config);
};

export const apiAgentsUpdateImap = (
  routeParams: {agent: string | number; [x: string]: unknown},
  body: App.Http.Requests.Auth.oAuth.StoreImapAuthRequest,
  config?: AxiosRequestConfig,
): Promise<AxiosResponse<App.DataObjects.TtrStatusResponse>> => {
  // Controller method: App\Http\Controllers\Api\Auth\oAuth\ImapAuthController::updateImap
  // URI: api/entities/agents/{agent}/imap
  return axios.patch(route("api.agents.update.imap", routeParams), body, config);
};

export const apiAgentsUpdateEws = (
  routeParams: {agent: string | number; [x: string]: unknown},
  body: App.Http.Requests.Auth.oAuth.StoreEwsAuthRequest,
  config?: AxiosRequestConfig,
): Promise<AxiosResponse<App.DataObjects.TtrStatusResponse>> => {
  // Controller method: App\Http\Controllers\Api\Auth\oAuth\EwsAuthController::updateEws
  // URI: api/entities/agents/{agent}/ews
  return axios.patch(route("api.agents.update.ews", routeParams), body, config);
};

export const apiAgentsDestroy = (routeParams: {agent: string | number; [x: string]: unknown}, config?: AxiosRequestConfig): Promise<AxiosResponse<App.DataObjects.TtrStatusResponse>> => {
  // Controller method: App\Http\Controllers\Api\Entities\AgentsController::destroy
  // URI: api/entities/agents/{agent}
  return axios.delete(route("api.agents.destroy", routeParams), config);
};

export const apiAgentsDestroyMulti = (routeParams?: {[x: string]: unknown}, body?: App.Http.Requests.Entities.AgentsDestroyMultipleRequest, config?: AxiosRequestConfig): Promise<AxiosResponse<App.DataObjects.TtrStatusResponse>> => {
  // Controller method: App\Http\Controllers\Api\Entities\AgentsController::destroyMultiple
  // URI: api/entities/agents/delete-multiple
  return axios.post(route("api.agents.destroy-multi", routeParams), body, config);
};

export const apiAgentsReAuth = (
  routeParams: App.Http.Requests.Entities.AgentsReAuthenticateRequest & {agent: string | number; [x: string]: unknown},
  config?: AxiosRequestConfig,
): Promise<AxiosResponse<{status: string} | {bulk: string} | {link: string} | {route: string}>> => {
  // Controller method: App\Http\Controllers\Api\Entities\AgentsController::reAuthenticate
  // URI: api/entities/agents/{agent}/re-auth
  // @ts-ignore the below error is because ziggy does not know about the shape of the query params
  return axios.get(route("api.agents.re-auth", routeParams), config);
};

export const apiAgentsUpdate = (routeParams: {agent: string | number; [x: string]: unknown}, body: App.Http.Requests.Entities.AgentsUpdateRequest, config?: AxiosRequestConfig): Promise<AxiosResponse<App.DataObjects.TtrStatusResponse>> => {
  // Controller method: App\Http\Controllers\Api\Entities\AgentsController::update
  // URI: api/entities/agents/{agent}/update
  return axios.patch(route("api.agents.update", routeParams), body, config);
};

export const apiAgentsUpdateTeams = (
  routeParams: {agent: string | number; [x: string]: unknown},
  body: App.Http.Requests.Entities.AgentsUpdateTeamsRequest,
  config?: AxiosRequestConfig,
): Promise<AxiosResponse<App.DataObjects.TtrStatusResponse>> => {
  // Controller method: App\Http\Controllers\Api\Entities\AgentsController::updateTeams
  // URI: api/entities/agents/{agent}/updateTeams
  return axios.patch(route("api.agents.updateTeams", routeParams), body, config);
};

export const apiAgentsUpdateGroupMailboxes = (
  routeParams: {agent: string | number; [x: string]: unknown},
  body: App.Http.Requests.Entities.AgentsUpdateGroupMailboxesRequest,
  config?: AxiosRequestConfig,
): Promise<AxiosResponse<App.DataObjects.TtrStatusResponse>> => {
  // Controller method: App\Http\Controllers\Api\Entities\AgentsController::updateGroupMailboxes
  // URI: api/entities/agents/{agent}/updateGroupMailboxes
  return axios.patch(route("api.agents.updateGroupMailboxes", routeParams), body, config);
};

export const apiAgentsSearchAll = (
  routeParams?: App.Http.Requests.Tools.CompanySearchEntitiesRequest & {[x: string]: unknown},
  config?: AxiosRequestConfig,
): Promise<AxiosResponse<{id: number; name: string; email?: string; type: number}[] | {api_id?: string; id?: number; name: string; email?: string; email_usernames: string[]; is_real_group?: boolean; userPrincipalName?: string}[]>> => {
  // Controller method: App\Http\Controllers\Api\Entities\AgentsController::searchAllCompanyMailboxes
  // URI: api/entities/agents/search-all-company-mailboxes
  // @ts-ignore the below error is because ziggy does not know about the shape of the query params
  return axios.get(route("api.agents.search-all", routeParams), config);
};

export const apiCrmMappingProperties = (
  routeParams?: App.Http.Requests.Tools.CrmMappingIndexRequest & {[x: string]: unknown},
  config?: AxiosRequestConfig,
): Promise<
  AxiosResponse<{
    contacts: Record<string, {label: string; type: string; options: any}>;
    companies: Record<string, {label: string; type: string; options: any}>;
    dealStages: Record<string, {id: string; label: string; isClosed: boolean; probability: number; crm_type: string}>;
  }>
> => {
  // Controller method: App\Http\Controllers\Api\Tools\CrmMappingController::index
  // URI: api/entities/crm-properties-mapping
  // @ts-ignore the below error is because ziggy does not know about the shape of the query params
  return axios.get(route("api.crm.mapping.properties", routeParams), config);
};

export const apiCrmMapping = (routeParams?: {[x: string]: unknown}, body?: App.Http.Requests.Tools.CrmMappingStoreRequest, config?: AxiosRequestConfig): Promise<AxiosResponse<string>> => {
  // Controller method: App\Http\Controllers\Api\Tools\CrmMappingController::store
  // URI: api/entities/crm-properties-mapping
  return axios.post(route("api.crm.mapping", routeParams), body, config);
};

export const apiCrmAdvancedMapping = (routeParams?: {[x: string]: unknown}, body?: App.Http.Requests.Tools.CrmMappingStoreAdvancedRequest, config?: AxiosRequestConfig): Promise<AxiosResponse<string>> => {
  // Controller method: App\Http\Controllers\Api\Tools\CrmMappingController::storeAdvanced
  // URI: api/entities/crm-properties-advanced-mapping
  return axios.post(route("api.crm.advanced.mapping", routeParams), body, config);
};

export const apiCrmDealSettingsStore = (routeParams?: {[x: string]: unknown}, body?: App.Http.Requests.Tools.CrmMappingStoreDealSettingsRequest, config?: AxiosRequestConfig): Promise<AxiosResponse<string>> => {
  // Controller method: App\Http\Controllers\Api\Tools\CrmMappingController::storeDealSettings
  // URI: api/entities/crm-deal-settings
  return axios.post(route("api.crm.deal-settings.store", routeParams), body, config);
};

export const apiCrmGetLists = (routeParams?: App.Http.Requests.Tools.CrmMappingGetListsRequest & {[x: string]: unknown}, config?: AxiosRequestConfig): Promise<AxiosResponse<{lists: {id: string | number; name: string}[]}>> => {
  // Controller method: App\Http\Controllers\Api\Tools\CrmMappingController::getLists
  // URI: api/entities/crm-properties/get-lists
  // @ts-ignore the below error is because ziggy does not know about the shape of the query params
  return axios.get(route("api.crm.get-lists", routeParams), config);
};

export const apiContactsIndex = (
  routeParams?: App.Http.Requests.Entities.CustomerIndexRequest & {[x: string]: unknown},
  config?: AxiosRequestConfig,
): Promise<AxiosResponse<{data: LaravelLengthAwarePaginator<App.Models.Customer>; filters: {search: string | null; sort_by: "id" | "name" | "type" | "is_lead"; sort_direction: "asc" | "desc"; per_page: number; page: number}}>> => {
  // Controller method: App\Http\Controllers\Api\Entities\CustomerController::index
  // URI: api/entities/contacts
  // @ts-ignore the below error is because ziggy does not know about the shape of the query params
  return axios.get(route("api.contacts.index", routeParams), config);
};

export const apiContactsStore = (routeParams?: {[x: string]: unknown}, body?: App.Http.Requests.Entities.CustomerStoreRequest, config?: AxiosRequestConfig): Promise<AxiosResponse<App.DataObjects.ElasticsearchEntityObject>> => {
  // Controller method: App\Http\Controllers\Api\Entities\CustomerController::store
  // URI: api/entities/contacts
  return axios.post(route("api.contacts.store", routeParams), body, config);
};

export const apiContactsUpdate = (
  routeParams: {contact: string | number; [x: string]: unknown},
  body: App.Http.Requests.Entities.CustomerUpdateRequest,
  config?: AxiosRequestConfig,
): Promise<AxiosResponse<App.DataObjects.ElasticsearchEntityObject>> => {
  // Controller method: App\Http\Controllers\Api\Entities\CustomerController::update
  // URI: api/entities/contacts/{contact}
  return axios.put(route("api.contacts.update", routeParams), body, config);
};

export const apiContactsDestroy = (routeParams: {contact: string | number; [x: string]: unknown}, config?: AxiosRequestConfig): Promise<AxiosResponse<App.DataObjects.TtrStatusResponse>> => {
  // Controller method: App\Http\Controllers\Api\Entities\CustomerController::destroy
  // URI: api/entities/contacts/{contact}
  return axios.delete(route("api.contacts.destroy", routeParams), config);
};

export const apiContactsDestroyMulti = (routeParams?: {[x: string]: unknown}, body?: App.Http.Requests.Entities.CustomerDestroyMultipleRequest, config?: AxiosRequestConfig): Promise<AxiosResponse<App.DataObjects.TtrStatusResponse>> => {
  // Controller method: App\Http\Controllers\Api\Entities\CustomerController::destroyMultiple
  // URI: api/entities/contacts/delete-multiple
  return axios.post(route("api.contacts.destroy-multi", routeParams), body, config);
};

export const apiContactsCreateFromCsv = (routeParams?: {[x: string]: unknown}, body?: App.Http.Requests.Entities.CustomerCreateFromCsvRequest, config?: AxiosRequestConfig): Promise<AxiosResponse<App.DataObjects.TtrStatusResponse>> => {
  // Controller method: App\Http\Controllers\Api\Entities\CustomerController::createFromCsv
  // URI: api/entities/contacts/create-from-csv
  return axios.postForm(route("api.contacts.create-from-csv", routeParams), body, config);
};

export const apiContactsSearchPossibleLeads = (routeParams?: App.Http.Requests.Entities.CustomerSearchPossibleLeadsRequest & {[x: string]: unknown}, config?: AxiosRequestConfig): Promise<AxiosResponse<{email: string}[]>> => {
  // Controller method: App\Http\Controllers\Api\Entities\CustomerController::searchPossibleLeads
  // URI: api/entities/contacts/search-possible-leads
  // @ts-ignore the below error is because ziggy does not know about the shape of the query params
  return axios.get(route("api.contacts.search-possible-leads", routeParams), config);
};

export const apiContactsStoreMulti = (routeParams?: {[x: string]: unknown}, body?: App.Http.Requests.Entities.CustomerStoreMultiRequest, config?: AxiosRequestConfig): Promise<AxiosResponse<App.Models.Customer[]>> => {
  // Controller method: App\Http\Controllers\Api\Entities\CustomerController::storeMulti
  // URI: api/entities/contacts/create-multi
  return axios.post(route("api.contacts.store-multi", routeParams), body, config);
};

export const apiContactGroupsIndex = (
  routeParams?: App.Http.Requests.Entities.CustomerGroupIndexRequest & {[x: string]: unknown},
  config?: AxiosRequestConfig,
): Promise<AxiosResponse<LaravelLengthAwarePaginator<{id: number; name: string}>>> => {
  // Controller method: App\Http\Controllers\Api\Entities\CustomerGroupController::index
  // URI: api/entities/contact-groups
  // @ts-ignore the below error is because ziggy does not know about the shape of the query params
  return axios.get(route("api.contact-groups.index", routeParams), config);
};

export const apiContactGroupsStore = (
  routeParams?: {[x: string]: unknown},
  body?: App.Http.Requests.Tools.StoreCustomerGroupRequest,
  config?: AxiosRequestConfig,
): Promise<AxiosResponse<{id: number; name: string; members: {emails: string[]; domains: string[]}}>> => {
  // Controller method: App\Http\Controllers\Api\Entities\CustomerGroupController::store
  // URI: api/entities/contact-groups
  return axios.postForm(route("api.contact-groups.store", routeParams), body, config);
};

export const apiContactGroupsShow = (routeParams: {contact_group: string | number; [x: string]: unknown}, config?: AxiosRequestConfig): Promise<AxiosResponse<App.DataObjects.ElasticsearchEntityObject>> => {
  // Controller method: App\Http\Controllers\Api\Entities\CustomerGroupController::show
  // URI: api/entities/contact-groups/{contact_group}
  return axios.get(route("api.contact-groups.show", routeParams), config);
};

export const apiContactGroupsUpdate = (
  routeParams: {contact_group: string | number; [x: string]: unknown},
  body: App.Http.Requests.Tools.StoreCustomerGroupRequest,
  config?: AxiosRequestConfig,
): Promise<AxiosResponse<{id: number; name: string; members: {emails: string[]; domains: string[]}}>> => {
  // Controller method: App\Http\Controllers\Api\Entities\CustomerGroupController::update
  // URI: api/entities/contact-groups/{contact_group}
  // @ts-ignore
  body._method = "PATCH";
  return axios.postForm(route("api.contact-groups.update", routeParams), body, config);
};

export const apiContactGroupsDestroy = (routeParams: {contact_group: string | number; [x: string]: unknown}, config?: AxiosRequestConfig): Promise<AxiosResponse<App.DataObjects.TtrStatusResponse>> => {
  // Controller method: App\Http\Controllers\Api\Entities\CustomerGroupController::destroy
  // URI: api/entities/contact-groups/{contact_group}
  return axios.delete(route("api.contact-groups.destroy", routeParams), config);
};

export const apiContactGroupsEmailsPush = (
  routeParams: {contact_group: string | number; [x: string]: unknown},
  body: App.Http.Requests.Entities.CustomerGroupPushEmailRequest,
  config?: AxiosRequestConfig,
): Promise<AxiosResponse<{id: number; name: string; members: {emails: string[]; domains: string[]}}>> => {
  // Controller method: App\Http\Controllers\Api\Entities\CustomerGroupController::pushEmail
  // URI: api/entities/contact-groups/{contact_group}/pushEmail
  return axios.patch(route("api.contact-groups.emails.push", routeParams), body, config);
};

export const apiContactGroupsEmailsDestroy = (
  routeParams: {contact_group: string | number; [x: string]: unknown},
  body: App.Http.Requests.Entities.CustomerGroupDeleteEmailRequest,
  config?: AxiosRequestConfig,
): Promise<AxiosResponse<{id: number; name: string; members: {emails: string[]; domains: string[]}}>> => {
  // Controller method: App\Http\Controllers\Api\Entities\CustomerGroupController::deleteEmail
  // URI: api/entities/contact-groups/{contact_group}/removeEmail
  return axios.patch(route("api.contact-groups.emails.destroy", routeParams), body, config);
};

export const apiContactGroupsMembersDestroy = (
  routeParams: {contact_group: string | number; [x: string]: unknown},
  body: App.Http.Requests.Entities.CustomerGroupDeleteMembersRequest,
  config?: AxiosRequestConfig,
): Promise<AxiosResponse<{id: number; name: string; members: {emails: string[]; domains: string[]}}>> => {
  // Controller method: App\Http\Controllers\Api\Entities\CustomerGroupController::deleteMembers
  // URI: api/entities/contact-groups/{contact_group}/removeMembers
  return axios.patch(route("api.contact-groups.members.destroy", routeParams), body, config);
};

export const apiContactGroupsDomainsPush = (
  routeParams: {contact_group: string | number; [x: string]: unknown},
  body: App.Http.Requests.Entities.CustomerGroupPushDomainRequest,
  config?: AxiosRequestConfig,
): Promise<AxiosResponse<{id: number; name: string; members: {emails: string[]; domains: string[]}}>> => {
  // Controller method: App\Http\Controllers\Api\Entities\CustomerGroupController::pushDomain
  // URI: api/entities/contact-groups/{contact_group}/pushDomain
  return axios.patch(route("api.contact-groups.domains.push", routeParams), body, config);
};

export const apiContactGroupsDomainsDestroy = (
  routeParams: {contact_group: string | number; [x: string]: unknown},
  body: App.Http.Requests.Entities.CustomerGroupDeleteDomainRequest,
  config?: AxiosRequestConfig,
): Promise<AxiosResponse<{id: number; name: string; members: {emails: string[]; domains: string[]}}>> => {
  // Controller method: App\Http\Controllers\Api\Entities\CustomerGroupController::deleteDomain
  // URI: api/entities/contact-groups/{contact_group}/removeDomain
  return axios.patch(route("api.contact-groups.domains.destroy", routeParams), body, config);
};

export const apiContactGroupsActiveCampaignStore = (routeParams?: {[x: string]: unknown}, body?: App.Http.Requests.Tools.ActiveCampaignCustomerGroupRequest, config?: AxiosRequestConfig): Promise<AxiosResponse<string>> => {
  // Controller method: App\Http\Controllers\Api\Entities\ActiveCampaignCustomerGroupController::store
  // URI: api/entities/contact-groups/active-campaign
  return axios.post(route("api.contact-groups-activeCampaign.store", routeParams), body, config);
};

export const apiContactGroupsActiveCampaignUpdate = (
  routeParams: {contact_group: string | number; [x: string]: unknown},
  body: App.Http.Requests.Tools.ActiveCampaignCustomerGroupRequest,
  config?: AxiosRequestConfig,
): Promise<AxiosResponse<string>> => {
  // Controller method: App\Http\Controllers\Api\Entities\ActiveCampaignCustomerGroupController::update
  // URI: api/entities/contact-groups/active-campaign/{contact_group}
  return axios.patch(route("api.contact-groups-activeCampaign.update", routeParams), body, config);
};

export const apiContactGroupsConstantContactStore = (
  routeParams?: {[x: string]: unknown},
  body?: App.Http.Requests.Tools.ConstantContactCustomerGroupRequest,
  config?: AxiosRequestConfig,
): Promise<AxiosResponse<App.DataObjects.TtrStatusResponse>> => {
  // Controller method: App\Http\Controllers\Api\Entities\ConstantContactCustomerGroupController::store
  // URI: api/entities/contact-groups/constant-contact
  return axios.post(route("api.contact-groups-constantContact.store", routeParams), body, config);
};

export const apiContactGroupsConstantContactUpdate = (
  routeParams: {contact_group: string | number; [x: string]: unknown},
  body: App.Http.Requests.Tools.ActiveCampaignCustomerGroupRequest,
  config?: AxiosRequestConfig,
): Promise<AxiosResponse<App.DataObjects.TtrStatusResponse>> => {
  // Controller method: App\Http\Controllers\Api\Entities\ConstantContactCustomerGroupController::update
  // URI: api/entities/contact-groups/constant-contact/{contact_group}
  return axios.patch(route("api.contact-groups-constantContact.update", routeParams), body, config);
};

export const apiContactGroupsHubspotStore = (routeParams?: {[x: string]: unknown}, body?: App.Http.Requests.Tools.HubspotCustomerGroupRequest, config?: AxiosRequestConfig): Promise<AxiosResponse<string>> => {
  // Controller method: App\Http\Controllers\Api\Entities\HubspotCustomerGroupController::store
  // URI: api/entities/contact-groups/hubspot
  return axios.post(route("api.contact-groups-hubspot.store", routeParams), body, config);
};

export const apiContactGroupsHubspotUpdate = (routeParams: {contact_group: string | number; [x: string]: unknown}, body: App.Http.Requests.Tools.HubspotCustomerGroupRequest, config?: AxiosRequestConfig): Promise<AxiosResponse<string>> => {
  // Controller method: App\Http\Controllers\Api\Entities\HubspotCustomerGroupController::update
  // URI: api/entities/contact-groups/hubspot/{contact_group}
  return axios.patch(route("api.contact-groups-hubspot.update", routeParams), body, config);
};

export const apiContactGroupsMaropostStore = (routeParams?: {[x: string]: unknown}, body?: App.Http.Requests.Tools.MaropostCustomerGroupRequest, config?: AxiosRequestConfig): Promise<AxiosResponse<string>> => {
  // Controller method: App\Http\Controllers\Api\Entities\MaropostCustomerGroupController::store
  // URI: api/entities/contact-groups/maropost
  return axios.post(route("api.contact-groups-maropost.store", routeParams), body, config);
};

export const apiContactGroupsMaropostUpdate = (
  routeParams: {contact_group: string | number; [x: string]: unknown},
  body: App.Http.Requests.Tools.MaropostCustomerGroupRequest,
  config?: AxiosRequestConfig,
): Promise<AxiosResponse<string>> => {
  // Controller method: App\Http\Controllers\Api\Entities\MaropostCustomerGroupController::update
  // URI: api/entities/contact-groups/maropost/{contact_group}
  return axios.patch(route("api.contact-groups-maropost.update", routeParams), body, config);
};

export const apiContactGroupsSalesforceStore = (routeParams?: {[x: string]: unknown}, body?: App.Http.Requests.Tools.SalesforceCustomerGroupRequest, config?: AxiosRequestConfig): Promise<AxiosResponse<string>> => {
  // Controller method: App\Http\Controllers\Api\Entities\SalesforceCustomerGroupController::store
  // URI: api/entities/contact-groups/salesforce
  return axios.post(route("api.contact-groups-salesforce.store", routeParams), body, config);
};

export const apiContactGroupsSalesforceUpdate = (
  routeParams: {contact_group: string | number; [x: string]: unknown},
  body: App.Http.Requests.Tools.SalesforceCustomerGroupRequest,
  config?: AxiosRequestConfig,
): Promise<AxiosResponse<string>> => {
  // Controller method: App\Http\Controllers\Api\Entities\SalesforceCustomerGroupController::update
  // URI: api/entities/contact-groups/salesforce/{contact_group}
  return axios.patch(route("api.contact-groups-salesforce.update", routeParams), body, config);
};

export const apiContactGroupsZohoStore = (routeParams?: {[x: string]: unknown}, body?: App.Http.Requests.Tools.ZohoCustomerGroupRequest, config?: AxiosRequestConfig): Promise<AxiosResponse<string>> => {
  // Controller method: App\Http\Controllers\Api\Entities\ZohoCustomerGroupController::store
  // URI: api/entities/contact-groups/zoho
  return axios.post(route("api.contact-groups-zoho.store", routeParams), body, config);
};

export const apiContactGroupsZohoUpdate = (routeParams: {contact_group: string | number; [x: string]: unknown}, body: App.Http.Requests.Tools.ZohoCustomerGroupRequest, config?: AxiosRequestConfig): Promise<AxiosResponse<string>> => {
  // Controller method: App\Http\Controllers\Api\Entities\ZohoCustomerGroupController::update
  // URI: api/entities/contact-groups/zoho/{contact_group}
  return axios.patch(route("api.contact-groups-zoho.update", routeParams), body, config);
};

export const apiGroupMailboxesIndex = (
  routeParams?: App.Http.Requests.Entities.GroupMailboxIndexRequest & {[x: string]: unknown},
  config?: AxiosRequestConfig,
): Promise<AxiosResponse<LaravelLengthAwarePaginator<App.DataObjects.ElasticsearchEntityObject>>> => {
  // Controller method: App\Http\Controllers\Api\Entities\GroupMailboxController::index
  // URI: api/entities/group-mailboxes
  // @ts-ignore the below error is because ziggy does not know about the shape of the query params
  return axios.get(route("api.group-mailboxes.index", routeParams), config);
};

export const apiGroupMailboxesStore = (routeParams?: {[x: string]: unknown}, body?: App.Http.Requests.Entities.GroupMailboxStoreRequest, config?: AxiosRequestConfig): Promise<AxiosResponse<GroupMailboxWithMembers>> => {
  // Controller method: App\Http\Controllers\Api\Entities\GroupMailboxController::store
  // URI: api/entities/group-mailboxes
  return axios.post(route("api.group-mailboxes.store", routeParams), body, config);
};

export const apiGroupMailboxesShow = (routeParams: {group_mailbox: string | number; [x: string]: unknown}, config?: AxiosRequestConfig): Promise<AxiosResponse<App.DataObjects.ElasticsearchEntityObject>> => {
  // Controller method: App\Http\Controllers\Api\Entities\GroupMailboxController::show
  // URI: api/entities/group-mailboxes/{group_mailbox}
  return axios.get(route("api.group-mailboxes.show", routeParams), config);
};

export const apiGroupMailboxesUpdate = (
  routeParams: {group_mailbox: string | number; [x: string]: unknown},
  body: App.Http.Requests.Entities.GroupMailboxUpdateRequest,
  config?: AxiosRequestConfig,
): Promise<AxiosResponse<GroupMailboxWithMembers>> => {
  // Controller method: App\Http\Controllers\Api\Entities\GroupMailboxController::update
  // URI: api/entities/group-mailboxes/{group_mailbox}
  return axios.put(route("api.group-mailboxes.update", routeParams), body, config);
};

export const apiGroupMailboxesDestroy = (routeParams: {group_mailbox: string | number; [x: string]: unknown}, config?: AxiosRequestConfig): Promise<AxiosResponse<App.DataObjects.TtrStatusResponse>> => {
  // Controller method: App\Http\Controllers\Api\Entities\GroupMailboxController::destroy
  // URI: api/entities/group-mailboxes/{group_mailbox}
  return axios.delete(route("api.group-mailboxes.destroy", routeParams), config);
};

export const apiGroupMailboxesMembersIndex = (
  routeParams: App.Http.Requests.Entities.GroupMailboxMembersIndexRequest & {group_mailbox: string | number; [x: string]: unknown},
  config?: AxiosRequestConfig,
): Promise<AxiosResponse<LaravelLengthAwarePaginator<App.DataObjects.GroupOrTeamMember>>> => {
  // Controller method: App\Http\Controllers\Api\Entities\GroupMailboxMembersController::index
  // URI: api/entities/group-mailboxes/{group_mailbox}/agents
  // @ts-ignore the below error is because ziggy does not know about the shape of the query params
  return axios.get(route("api.group-mailboxes.members.index", routeParams), config);
};

export const apiGroupMailboxesMembersAdd = (
  routeParams: {group_mailbox: string | number; [x: string]: unknown},
  body: App.Http.Requests.Entities.GroupMailboxMembersAddRequest,
  config?: AxiosRequestConfig,
): Promise<AxiosResponse<LaravelLengthAwarePaginator<App.Models.Agent>>> => {
  // Controller method: App\Http\Controllers\Api\Entities\GroupMailboxMembersController::add
  // URI: api/entities/group-mailboxes/{group_mailbox}/agents
  return axios.post(route("api.group-mailboxes.members.add", routeParams), body, config);
};

export const apiGroupMailboxesMembersDestroy = (
  routeParams: App.Http.Requests.Entities.GroupMailboxMembersRemoveRequest & {group_mailbox: string | number; [x: string]: unknown},
  config?: AxiosRequestConfig,
): Promise<AxiosResponse<LaravelLengthAwarePaginator<App.Models.Agent>>> => {
  // Controller method: App\Http\Controllers\Api\Entities\GroupMailboxMembersController::remove
  // URI: api/entities/group-mailboxes/{group_mailbox}/agents
  // @ts-ignore the below error is because ziggy does not know about the shape of the query params
  return axios.delete(route("api.group-mailboxes.members.destroy", routeParams), config);
};

export const apiTeamsIndex = (
  routeParams?: App.Http.Requests.Entities.TeamsIndexRequest & {[x: string]: unknown},
  config?: AxiosRequestConfig,
): Promise<AxiosResponse<LaravelLengthAwarePaginator<App.DataObjects.ElasticsearchEntityObject>>> => {
  // Controller method: App\Http\Controllers\Api\Entities\TeamsController::index
  // URI: api/entities/teams
  // @ts-ignore the below error is because ziggy does not know about the shape of the query params
  return axios.get(route("api.teams.index", routeParams), config);
};

export const apiTeamsStore = (routeParams?: {[x: string]: unknown}, body?: App.Http.Requests.Entities.TeamsStoreRequest, config?: AxiosRequestConfig): Promise<AxiosResponse<TeamWithMembers>> => {
  // Controller method: App\Http\Controllers\Api\Entities\TeamsController::store
  // URI: api/entities/teams
  return axios.post(route("api.teams.store", routeParams), body, config);
};

export const apiTeamsShow = (routeParams: {team: string | number; [x: string]: unknown}, config?: AxiosRequestConfig): Promise<AxiosResponse<App.DataObjects.ElasticsearchEntityObject>> => {
  // Controller method: App\Http\Controllers\Api\Entities\TeamsController::show
  // URI: api/entities/teams/{team}
  return axios.get(route("api.teams.show", routeParams), config);
};

export const apiTeamsUpdate = (routeParams: {team: string | number; [x: string]: unknown}, body: App.Http.Requests.Entities.TeamsUpdateRequest, config?: AxiosRequestConfig): Promise<AxiosResponse<TeamWithMembers>> => {
  // Controller method: App\Http\Controllers\Api\Entities\TeamsController::update
  // URI: api/entities/teams/{team}
  return axios.put(route("api.teams.update", routeParams), body, config);
};

export const apiTeamsDestroy = (routeParams: {team: string | number; [x: string]: unknown}, config?: AxiosRequestConfig): Promise<AxiosResponse<App.DataObjects.TtrStatusResponse>> => {
  // Controller method: App\Http\Controllers\Api\Entities\TeamsController::destroy
  // URI: api/entities/teams/{team}
  return axios.delete(route("api.teams.destroy", routeParams), config);
};

export const apiTeamsCreateFromCsv = (routeParams?: {[x: string]: unknown}, body?: App.Http.Requests.Entities.TeamsCreateFromCsvRequest, config?: AxiosRequestConfig): Promise<AxiosResponse<App.DataObjects.TtrStatusResponse>> => {
  // Controller method: App\Http\Controllers\Api\Entities\TeamsController::createFromCsv
  // URI: api/entities/teams/create-from-csv
  return axios.postForm(route("api.teams.create-from-csv", routeParams), body, config);
};

export const apiTeamsMembersIndex = (
  routeParams: App.Http.Requests.Entities.TeamMembersIndexRequest & {team: string | number; [x: string]: unknown},
  config?: AxiosRequestConfig,
): Promise<AxiosResponse<LaravelLengthAwarePaginator<App.DataObjects.GroupOrTeamMember>>> => {
  // Controller method: App\Http\Controllers\Api\Entities\TeamMembersController::index
  // URI: api/entities/teams/{team}/agents
  // @ts-ignore the below error is because ziggy does not know about the shape of the query params
  return axios.get(route("api.teams.members.index", routeParams), config);
};

export const apiTeamsMembersAdd = (
  routeParams: {team: string | number; [x: string]: unknown},
  body: App.Http.Requests.Entities.TeamMembersAddRequest,
  config?: AxiosRequestConfig,
): Promise<AxiosResponse<LaravelLengthAwarePaginator<App.Models.Agent>>> => {
  // Controller method: App\Http\Controllers\Api\Entities\TeamMembersController::add
  // URI: api/entities/teams/{team}/agents
  return axios.post(route("api.teams.members.add", routeParams), body, config);
};

export const apiTeamsMembersDestroy = (
  routeParams: App.Http.Requests.Entities.TeamMembersRemoveRequest & {team: string | number; [x: string]: unknown},
  config?: AxiosRequestConfig,
): Promise<AxiosResponse<LaravelLengthAwarePaginator<App.Models.Agent>>> => {
  // Controller method: App\Http\Controllers\Api\Entities\TeamMembersController::remove
  // URI: api/entities/teams/{team}/agents
  // @ts-ignore the below error is because ziggy does not know about the shape of the query params
  return axios.delete(route("api.teams.members.destroy", routeParams), config);
};

export const apiLabelsSearch = (
  routeParams?: App.Http.Requests.Entities.LabelsSearchLabelsRequest & {[x: string]: unknown},
  config?: AxiosRequestConfig,
): Promise<AxiosResponse<LaravelLengthAwarePaginator<App.DataObjects.ElasticsearchEntityObject>>> => {
  // Controller method: App\Http\Controllers\Api\Entities\LabelsController::searchLabels
  // URI: api/entities/labels/search
  // @ts-ignore the below error is because ziggy does not know about the shape of the query params
  return axios.get(route("api.labels.search", routeParams), config);
};

export const apiSettingsHideGroupTeamsModal = (routeParams?: {[x: string]: unknown}, body?: any, config?: AxiosRequestConfig): Promise<AxiosResponse<string>> => {
  // Controller method: App\Http\Controllers\Api\Tools\AccountController::hideGroupTeamsModal
  // URI: api/tools/settings/message-filters/hide-group-teams-modal
  return axios.post(route("api.settings.hide-group-teams-modal", routeParams), body, config);
};

export const apiSettingsHideGroupTeams = (routeParams?: {[x: string]: unknown}, body?: any, config?: AxiosRequestConfig): Promise<AxiosResponse<string>> => {
  // Controller method: App\Http\Controllers\Api\Tools\AccountController::hideGroupTeams
  // URI: api/tools/settings/message-filters/hide-group-teams
  return axios.post(route("api.settings.hide-group-teams", routeParams), body, config);
};

export const apiMessageFiltersAll = (
  routeParams?: App.Http.Requests.Tools.MessageFilterGetAllThreadFilterDataRequest & {[x: string]: unknown},
  config?: AxiosRequestConfig,
): Promise<
  AxiosResponse<{
    advanced_filters_count: {
      active: number;
      total: number;
    };
    domain_and_email_filters: {
      domains: number;
      emails: number;
    };
    agents: App.DataObjects.ElasticsearchEntityObject[];
    teams: App.DataObjects.ElasticsearchEntityObject[];
    group_mailboxes: App.DataObjects.ElasticsearchEntityObject[];
    customer_groups: App.DataObjects.ElasticsearchEntityObject[];
    customers: App.DataObjects.ElasticsearchEntityObject[];
    lead_sources: App.DataObjects.ElasticsearchEntityObject[];
    goals: App.DataObjects.CompanyReplyTimeGoalsDataObject;
    cached: boolean;
    impersonating: boolean;
    session_filters: any;
  }>
> => {
  // Controller method: App\Http\Controllers\Api\Tools\MessageFilterController::getAllThreadFilterData
  // URI: api/tools/settings/message-filters/all-thread-filter-data
  // @ts-ignore the below error is because ziggy does not know about the shape of the query params
  return axios.get(route("api.message-filters.all", routeParams), config);
};

export const apiMessageFiltersDomainsIndex = (
  routeParams?: App.Http.Requests.Tools.MessageFilterGetDomainFiltersRequest & {[x: string]: unknown},
  config?: AxiosRequestConfig,
): Promise<AxiosResponse<{domains: LaravelLengthAwarePaginator<string>; whitelisting: boolean}>> => {
  // Controller method: App\Http\Controllers\Api\Tools\MessageFilterController::getDomainFilters
  // URI: api/tools/settings/message-filters/domains
  // @ts-ignore the below error is because ziggy does not know about the shape of the query params
  return axios.get(route("api.message-filters.domains.index", routeParams), config);
};

export const apiMessageFiltersDomainsBlock = (routeParams?: {[x: string]: unknown}, body?: App.Http.Requests.Tools.MessageFilterBlockDomainsRequest, config?: AxiosRequestConfig): Promise<AxiosResponse<App.Models.EmailDomain[]>> => {
  // Controller method: App\Http\Controllers\Api\Tools\MessageFilterController::blockDomains
  // URI: api/tools/settings/message-filters/domains/block
  return axios.post(route("api.message-filters.domains.block", routeParams), body, config);
};

export const apiMessageFiltersDomainsUnblock = (
  routeParams?: {[x: string]: unknown},
  body?: App.Http.Requests.Tools.MessageFilterUnblockDomainsRequest,
  config?: AxiosRequestConfig,
): Promise<AxiosResponse<App.DataObjects.TtrStatusResponse>> => {
  // Controller method: App\Http\Controllers\Api\Tools\MessageFilterController::unblockDomains
  // URI: api/tools/settings/message-filters/domains/unblock
  return axios.post(route("api.message-filters.domains.unblock", routeParams), body, config);
};

export const apiMessageFiltersDomainsUnblockAll = (routeParams?: {[x: string]: unknown}, body?: any, config?: AxiosRequestConfig): Promise<AxiosResponse<App.DataObjects.TtrStatusResponse>> => {
  // Controller method: App\Http\Controllers\Api\Tools\MessageFilterController::unblockAllDomains
  // URI: api/tools/settings/message-filters/domains/unblockAll
  return axios.post(route("api.message-filters.domains.unblockAll", routeParams), body, config);
};

export const apiMessageFiltersWhitelistingToggle = (
  routeParams?: {[x: string]: unknown},
  body?: App.Http.Requests.Tools.MessageFilterToggleWhitelistingRequest,
  config?: AxiosRequestConfig,
): Promise<AxiosResponse<App.DataObjects.TtrStatusResponse>> => {
  // Controller method: App\Http\Controllers\Api\Tools\MessageFilterController::toggleWhitelisting
  // URI: api/tools/settings/message-filters/domains/whitelisting/toggle
  return axios.patch(route("api.message-filters.whitelisting.toggle", routeParams), body, config);
};

export const apiMessageFiltersMaxReplyTimesIndex = (routeParams?: {[x: string]: unknown}, config?: AxiosRequestConfig): Promise<AxiosResponse<{max_reply_time_enabled: boolean; max_reply_time_hrs: number}>> => {
  // Controller method: App\Http\Controllers\Api\Tools\MessageFilterController::getMaxReplyTimeSettings
  // URI: api/tools/settings/message-filters/max-reply-time
  return axios.get(route("api.message-filters.max-reply-times.index", routeParams), config);
};

export const apiMessageFiltersMaxReplyTimesUpdate = (
  routeParams?: {[x: string]: unknown},
  body?: App.Http.Requests.Tools.MessageFilterUpdateMaxReplyTimeSettingsRequest,
  config?: AxiosRequestConfig,
): Promise<AxiosResponse<{max_reply_time_enabled: boolean; max_reply_time_hrs: number}>> => {
  // Controller method: App\Http\Controllers\Api\Tools\MessageFilterController::updateMaxReplyTimeSettings
  // URI: api/tools/settings/message-filters/max-reply-time
  return axios.patch(route("api.message-filters.max-reply-times.update", routeParams), body, config);
};

export const apiMessageFiltersUsernamesIndex = (
  routeParams?: App.Http.Requests.Tools.MessageFilterGetUsernameFiltersRequest & {[x: string]: unknown},
  config?: AxiosRequestConfig,
): Promise<AxiosResponse<LaravelLengthAwarePaginator<string>>> => {
  // Controller method: App\Http\Controllers\Api\Tools\MessageFilterController::getUsernameFilters
  // URI: api/tools/settings/message-filters/usernames
  // @ts-ignore the below error is because ziggy does not know about the shape of the query params
  return axios.get(route("api.message-filters.usernames.index", routeParams), config);
};

export const apiMessageFiltersUsernamesBlock = (routeParams?: {[x: string]: unknown}, body?: App.Http.Requests.Tools.MessageFilterBlockUsernamesRequest, config?: AxiosRequestConfig): Promise<AxiosResponse<App.Models.EmailUsername[]>> => {
  // Controller method: App\Http\Controllers\Api\Tools\MessageFilterController::blockUsernames
  // URI: api/tools/settings/message-filters/usernames/block
  return axios.post(route("api.message-filters.usernames.block", routeParams), body, config);
};

export const apiMessageFiltersUsernamesBlockCsv = (
  routeParams?: {[x: string]: unknown},
  body?: App.Http.Requests.Tools.MessageFilterBlockUsernamesCsvRequest,
  config?: AxiosRequestConfig,
): Promise<AxiosResponse<App.Models.EmailUsername[]>> => {
  // Controller method: App\Http\Controllers\Api\Tools\MessageFilterController::blockUsernamesCsv
  // URI: api/tools/settings/message-filters/usernames/block-csv
  return axios.postForm(route("api.message-filters.usernames.block.csv", routeParams), body, config);
};

export const apiMessageFiltersUsernamesUnblock = (
  routeParams?: {[x: string]: unknown},
  body?: App.Http.Requests.Tools.MessageFilterUnblockUsernamesRequest,
  config?: AxiosRequestConfig,
): Promise<AxiosResponse<App.DataObjects.TtrStatusResponse>> => {
  // Controller method: App\Http\Controllers\Api\Tools\MessageFilterController::unblockUsernames
  // URI: api/tools/settings/message-filters/usernames/unblock
  return axios.post(route("api.message-filters.usernames.unblock", routeParams), body, config);
};

export const apiMessageFiltersIndex = (
  routeParams?: App.Http.Requests.Tools.MessageFilterGetFiltersRequest & {[x: string]: unknown},
  config?: AxiosRequestConfig,
): Promise<AxiosResponse<LaravelLengthAwarePaginator<App.Models.MessageFilterGroup>>> => {
  // Controller method: App\Http\Controllers\Api\Tools\MessageFilterController::getFilters
  // URI: api/tools/settings/message-filters/advanced
  // @ts-ignore the below error is because ziggy does not know about the shape of the query params
  return axios.get(route("api.message-filters.index", routeParams), config);
};

export const apiMessageFiltersStore = (routeParams?: {[x: string]: unknown}, body?: App.Http.Requests.Tools.StoreMessageFilterRequest, config?: AxiosRequestConfig): Promise<AxiosResponse<App.Models.MessageFilterGroup>> => {
  // Controller method: App\Http\Controllers\Api\Tools\MessageFilterController::store
  // URI: api/tools/settings/message-filters/advanced
  return axios.post(route("api.message-filters.store", routeParams), body, config);
};

export const apiMessageFiltersUpdate = (
  routeParams: {message_filter_group: string | number; [x: string]: unknown},
  body: App.Http.Requests.Tools.StoreMessageFilterRequest,
  config?: AxiosRequestConfig,
): Promise<AxiosResponse<App.Models.MessageFilterGroup>> => {
  // Controller method: App\Http\Controllers\Api\Tools\MessageFilterController::update
  // URI: api/tools/settings/message-filters/advanced/{message_filter_group}
  return axios.patch(route("api.message-filters.update", routeParams), body, config);
};

export const apiMessageFiltersDestroy = (routeParams: {message_filter_group: string | number; [x: string]: unknown}, config?: AxiosRequestConfig): Promise<AxiosResponse<App.DataObjects.TtrStatusResponse>> => {
  // Controller method: App\Http\Controllers\Api\Tools\MessageFilterController::destroy
  // URI: api/tools/settings/message-filters/advanced/{message_filter_group}
  return axios.delete(route("api.message-filters.destroy", routeParams), config);
};

export const apiMessageFiltersToggle = (routeParams: {message_filter_group: string | number; [x: string]: unknown}, body: any, config?: AxiosRequestConfig): Promise<AxiosResponse<App.Models.MessageFilterGroup>> => {
  // Controller method: App\Http\Controllers\Api\Tools\MessageFilterController::toggleActive
  // URI: api/tools/settings/message-filters/advanced/{message_filter_group}/toggle
  return axios.patch(route("api.message-filters.toggle", routeParams), body, config);
};

export const apiWebNotificationStore = (routeParams?: {[x: string]: unknown}, body?: App.Http.Requests.Tools.WebNotificationStoreRequest, config?: AxiosRequestConfig): Promise<AxiosResponse<App.DataObjects.TtrSuccessResponse>> => {
  // Controller method: App\Http\Controllers\Api\Tools\WebNotificationController::store
  // URI: api/tools/settings/message-filters/web-notification
  return axios.post(route("api.web-notification.store", routeParams), body, config);
};

export const apiWebNotificationDestroy = (routeParams?: {[x: string]: unknown}, body?: App.Http.Requests.Tools.WebNotificationDestroyRequest, config?: AxiosRequestConfig): Promise<AxiosResponse<null>> => {
  // Controller method: App\Http\Controllers\Api\Tools\WebNotificationController::destroy
  // URI: api/tools/settings/message-filters/web-notification/delete
  return axios.post(route("api.web-notification.destroy", routeParams), body, config);
};

export const apiProfileSendVerificationEmail = (routeParams?: {[x: string]: unknown}, body?: any, config?: AxiosRequestConfig): Promise<AxiosResponse<string>> => {
  // Controller method: App\Http\Controllers\Api\Tools\AccountController::sendVerificationEmail
  // URI: api/tools/settings/send-verification-email
  return axios.post(route("api.profile.send-verification-email", routeParams), body, config);
};

export const apiReplyTimeGoalsIndex = (routeParams?: {[x: string]: unknown}, config?: AxiosRequestConfig): Promise<AxiosResponse<App.DataObjects.CompanyReplyTimeGoalsDataObject>> => {
  // Controller method: App\Http\Controllers\Api\Tools\ReplyTimeGoalsController::index
  // URI: api/tools/settings/reply-time-goals
  return axios.get(route("api.reply-time-goals.index", routeParams), config);
};

export const apiReplyTimeGoalsUpdate = (
  routeParams?: {[x: string]: unknown},
  body?: App.Http.Requests.Tools.ReplyTimeGoalsUpdateRequest,
  config?: AxiosRequestConfig,
): Promise<AxiosResponse<App.DataObjects.CompanyReplyTimeGoalsDataObject>> => {
  // Controller method: App\Http\Controllers\Api\Tools\ReplyTimeGoalsController::update
  // URI: api/tools/settings/reply-time-goals
  return axios.patch(route("api.reply-time-goals.update", routeParams), body, config);
};

export const apiProfileDestroy = (routeParams?: {[x: string]: unknown}, config?: AxiosRequestConfig): Promise<AxiosResponse<App.DataObjects.TtrStatusResponse>> => {
  // Controller method: App\Http\Controllers\Api\Tools\ProfileController::destroy
  // URI: api/tools/settings/profile
  return axios.delete(route("api.profile.destroy", routeParams), config);
};

export const apiProfileDestroyCompanyAccount = (
  routeParams?: {[x: string]: unknown},
  body?: App.Http.Requests.Tools.ProfileDestroyCompanyAccountRequest,
  config?: AxiosRequestConfig,
): Promise<AxiosResponse<App.DataObjects.TtrStatusResponse>> => {
  // Controller method: App\Http\Controllers\Api\Tools\ProfileController::destroyCompanyAccount
  // URI: api/tools/settings/profile/company
  return axios.post(route("api.profile.destroyCompanyAccount", routeParams), body, config);
};

export const apiProfileSupplyExtraDetails = (routeParams?: {[x: string]: unknown}, body?: App.Http.Requests.Tools.ProfileSupplyExtraDetailsRequest, config?: AxiosRequestConfig): Promise<AxiosResponse<App.DataObjects.TtrStatusResponse>> => {
  // Controller method: App\Http\Controllers\Api\Tools\ProfileController::supplyExtraDetails
  // URI: api/tools/settings/profile
  return axios.post(route("api.profile.supplyExtraDetails", routeParams), body, config);
};

export const apiProfileHubspotData = (routeParams?: {[x: string]: unknown}, body?: App.Http.Requests.Tools.ProfileAddHubspotDataRequest, config?: AxiosRequestConfig): Promise<AxiosResponse<string>> => {
  // Controller method: App\Http\Controllers\Api\Tools\ProfileController::addHubspotData
  // URI: api/tools/settings/profile/hubspot-data
  return axios.post(route("api.profile.hubspot-data", routeParams), body, config);
};

export const apiPreferencesToggleProductType = (routeParams?: {[x: string]: unknown}, body?: any, config?: AxiosRequestConfig): Promise<AxiosResponse<string>> => {
  // Controller method: App\Http\Controllers\Api\Tools\AccountController::toggleProductTypePreference
  // URI: api/tools/settings/preferences/toggle-product-type
  return axios.patch(route("api.preferences.toggle-product-type", routeParams), body, config);
};

export const apiViewsIndex = (routeParams?: App.Http.Requests.Tools.ViewIndexRequest & {[x: string]: unknown}, config?: AxiosRequestConfig): Promise<AxiosResponse<LaravelLengthAwarePaginator<App.Models.View>>> => {
  // Controller method: App\Http\Controllers\Api\Tools\ViewController::index
  // URI: api/tools/views
  // @ts-ignore the below error is because ziggy does not know about the shape of the query params
  return axios.get(route("api.views.index", routeParams), config);
};

export const apiViewsStore = (routeParams?: {[x: string]: unknown}, body?: App.Http.Requests.Tools.StoreViewRequest, config?: AxiosRequestConfig): Promise<AxiosResponse<App.Models.View>> => {
  // Controller method: App\Http\Controllers\Api\Tools\ViewController::store
  // URI: api/tools/views
  return axios.post(route("api.views.store", routeParams), body, config);
};

export const apiViewsShow = (routeParams: {view: string | number; [x: string]: unknown}, config?: AxiosRequestConfig): Promise<AxiosResponse<App.Models.View>> => {
  // Controller method: App\Http\Controllers\Api\Tools\ViewController::show
  // URI: api/tools/views/{view}
  return axios.get(route("api.views.show", routeParams), config);
};

export const apiViewsUpdate = (routeParams: {view: string | number; [x: string]: unknown}, body: App.Http.Requests.Tools.StoreViewRequest, config?: AxiosRequestConfig): Promise<AxiosResponse<App.Models.View>> => {
  // Controller method: App\Http\Controllers\Api\Tools\ViewController::update
  // URI: api/tools/views/{view}
  return axios.put(route("api.views.update", routeParams), body, config);
};

export const apiViewsDestroy = (routeParams: {view: string | number; [x: string]: unknown}, config?: AxiosRequestConfig): Promise<AxiosResponse<App.DataObjects.TtrStatusResponse>> => {
  // Controller method: App\Http\Controllers\Api\Tools\ViewController::destroy
  // URI: api/tools/views/{view}
  return axios.delete(route("api.views.destroy", routeParams), config);
};

export const apiScheduledReportsIndex = (
  routeParams?: App.Http.Requests.Tools.ScheduledReportIndexRequest & {[x: string]: unknown},
  config?: AxiosRequestConfig,
): Promise<AxiosResponse<LaravelLengthAwarePaginator<App.Models.ReportSchedule>>> => {
  // Controller method: App\Http\Controllers\Api\Tools\ScheduledReportController::index
  // URI: api/tools/scheduled-reports
  // @ts-ignore the below error is because ziggy does not know about the shape of the query params
  return axios.get(route("api.scheduled-reports.index", routeParams), config);
};

export const apiScheduledReportsWidgetsList = (
  routeParams?: {[x: string]: unknown},
  body?: App.Http.Requests.Tools.ScheduledReportGetWidgetsListRequest,
  config?: AxiosRequestConfig,
): Promise<
  AxiosResponse<{
    widgetsList: {
      name: string;
      type: string;
      selected: boolean;
      options: {
        columns?: {
          field: string;
          sortable: boolean;
          centered: boolean;
          label: string;
          visible: boolean;
          hasComparison: boolean;
          group?: string;
          hasEmails?: boolean;
          headerClass?: string;
          hasGoals?: boolean;
          tooltip?: string;
        }[];
        rows?: {
          field: string;
          visible: boolean;
        }[];
      };
    }[];
  }>
> => {
  // Controller method: App\Http\Controllers\Api\Tools\ScheduledReportController::getWidgetsList
  // URI: api/tools/scheduled-reports/widgets-list
  return axios.post(route("api.scheduled-reports.widgets-list", routeParams), body, config);
};

export const apiScheduledReportsStore = (routeParams?: {[x: string]: unknown}, body?: App.Http.Requests.Reports.StoreReportScheduleRequest, config?: AxiosRequestConfig): Promise<AxiosResponse<App.Models.ReportSchedule>> => {
  // Controller method: App\Http\Controllers\Api\Tools\ScheduledReportController::store
  // URI: api/tools/scheduled-reports
  return axios.postForm(route("api.scheduled-reports.store", routeParams), body, config);
};

export const apiScheduledReportsShow = (
  routeParams: App.Http.Requests.Tools.ScheduledReportShowRequest & {scheduled_report: string | number; [x: string]: unknown},
  config?: AxiosRequestConfig,
): Promise<AxiosResponse<App.Models.ReportSchedule>> => {
  // Controller method: App\Http\Controllers\Api\Tools\ScheduledReportController::show
  // URI: api/tools/scheduled-reports/{scheduled_report}
  // @ts-ignore the below error is because ziggy does not know about the shape of the query params
  return axios.get(route("api.scheduled-reports.show", routeParams), config);
};

export const apiScheduledReportsUpdate = (
  routeParams: {scheduled_report: string | number; [x: string]: unknown},
  body: App.Http.Requests.Reports.StoreReportScheduleRequest,
  config?: AxiosRequestConfig,
): Promise<AxiosResponse<App.Models.ReportSchedule>> => {
  // Controller method: App\Http\Controllers\Api\Tools\ScheduledReportController::update
  // URI: api/tools/scheduled-reports/{scheduled_report}
  // @ts-ignore
  body._method = "PATCH";
  return axios.postForm(route("api.scheduled-reports.update", routeParams), body, config);
};

export const apiScheduledReportsDestroy = (routeParams: {scheduled_report: string | number; [x: string]: unknown}, config?: AxiosRequestConfig): Promise<AxiosResponse<App.DataObjects.TtrStatusResponse>> => {
  // Controller method: App\Http\Controllers\Api\Tools\ScheduledReportController::destroy
  // URI: api/tools/scheduled-reports/{scheduled_report}
  return axios.delete(route("api.scheduled-reports.destroy", routeParams), config);
};

export const apiReportsIndex = (
  routeParams?: App.Http.Requests.Tools.ReportIndexRequest & {[x: string]: unknown},
  config?: AxiosRequestConfig,
): Promise<AxiosResponse<Array<{name: string; id: number; type: "Report" | "Scheduled Report"}> | LaravelLengthAwarePaginator<{name: string; id: number; type: "Report" | "Scheduled Report"}>>> => {
  // Controller method: App\Http\Controllers\Api\Tools\ReportController::index
  // URI: api/tools/reports
  // @ts-ignore the below error is because ziggy does not know about the shape of the query params
  return axios.get(route("api.reports.index", routeParams), config);
};

export const apiReportsStore = (routeParams?: {[x: string]: unknown}, body?: App.Http.Requests.Reports.StoreReportRequest, config?: AxiosRequestConfig): Promise<AxiosResponse<App.Models.Report>> => {
  // Controller method: App\Http\Controllers\Api\Tools\ReportController::store
  // URI: api/tools/reports
  return axios.post(route("api.reports.store", routeParams), body, config);
};

export const apiReportsShare = (routeParams?: {[x: string]: unknown}, body?: App.Http.Requests.Reports.ShareReportRequest, config?: AxiosRequestConfig): Promise<AxiosResponse<App.DataObjects.TtrStatusResponse>> => {
  // Controller method: App\Http\Controllers\Api\Tools\ReportController::share
  // URI: api/tools/reports/share
  return axios.post(route("api.reports.share", routeParams), body, config);
};

export const apiReportsShow = (routeParams: App.Http.Requests.Tools.ReportShowRequest & {report: string | number; [x: string]: unknown}, config?: AxiosRequestConfig): Promise<AxiosResponse<App.Models.Report>> => {
  // Controller method: App\Http\Controllers\Api\Tools\ReportController::show
  // URI: api/tools/reports/{report}
  // @ts-ignore the below error is because ziggy does not know about the shape of the query params
  return axios.get(route("api.reports.show", routeParams), config);
};

export const apiReportsUpdate = (routeParams: {report: string | number; [x: string]: unknown}, body: App.Http.Requests.Reports.StoreReportRequest, config?: AxiosRequestConfig): Promise<AxiosResponse<App.Models.Report>> => {
  // Controller method: App\Http\Controllers\Api\Tools\ReportController::update
  // URI: api/tools/reports/{report}
  return axios.patch(route("api.reports.update", routeParams), body, config);
};

export const apiReportsDestroy = (routeParams: {report: string | number; [x: string]: unknown}, config?: AxiosRequestConfig): Promise<AxiosResponse<App.DataObjects.TtrStatusResponse>> => {
  // Controller method: App\Http\Controllers\Api\Tools\ReportController::destroy
  // URI: api/tools/reports/{report}
  return axios.delete(route("api.reports.destroy", routeParams), config);
};

export const apiAlertsConversations = (
  routeParams: {alert: string | number; [x: string]: unknown},
  config?: AxiosRequestConfig,
): Promise<AxiosResponse<{data: App.DataObjects.AlertThreadData[]; signedClosingLink: string; signedSnoozeLink: string}>> => {
  // Controller method: App\Http\Controllers\Api\Tools\AlertController::indexConversations
  // URI: api/tools/alerts/{alert}/conversations
  return axios.get(route("api.alerts.conversations", routeParams), config);
};

export const apiAlertsDestroyMulti = (routeParams?: {[x: string]: unknown}, body?: App.Http.Requests.Tools.AlertDestroyMultipleRequest, config?: AxiosRequestConfig): Promise<AxiosResponse<App.DataObjects.TtrStatusResponse>> => {
  // Controller method: App\Http\Controllers\Api\Tools\AlertController::destroyMultiple
  // URI: api/tools/alerts/delete-multiple
  return axios.post(route("api.alerts.destroy-multi", routeParams), body, config);
};

export const apiAlertsIndex = (
  routeParams?: App.Http.Requests.Tools.AlertIndexRequest & {[x: string]: unknown},
  config?: AxiosRequestConfig,
): Promise<
  AxiosResponse<
    LaravelLengthAwarePaginator<{
      id: number;
      name: string;
      alert_after_minutes: number;
      use_business_hours: boolean;
      type: "external" | "internal" | "anybody";
      notify_types: Array<"all_agents" | "custom_emails">;
      custom_emails: string[];
      enabled: boolean;
      reply_to_operator: App.Enums.LogicalOperator;
      create_crm_tasks: boolean;
      selected_entities: App.DataObjects.ElasticsearchEntityObject[];
      selected_model: null;
      in_conversation: boolean;
      exclude_emails: string[];
      exclude_domains: string[];
    }>
  >
> => {
  // Controller method: App\Http\Controllers\Api\Tools\AlertController::index
  // URI: api/tools/alerts
  // @ts-ignore the below error is because ziggy does not know about the shape of the query params
  return axios.get(route("api.alerts.index", routeParams), config);
};

export const apiAlertsStore = (
  routeParams?: {[x: string]: unknown},
  body?: App.Http.Requests.Tools.StoreAlertRequest,
  config?: AxiosRequestConfig,
): Promise<
  AxiosResponse<{
    id: number;
    name: string;
    alert_after_minutes: number;
    use_business_hours: boolean;
    type: "external" | "internal" | "anybody";
    notify_types: Array<"all_agents" | "custom_emails">;
    custom_emails: string[];
    enabled: boolean;
    reply_to_operator: App.Enums.LogicalOperator;
    create_crm_tasks: boolean;
    selected_entities: App.DataObjects.ElasticsearchEntityObject[];
    selected_model: null;
    in_conversation: boolean;
    exclude_emails: string[];
    exclude_domains: string[];
  }>
> => {
  // Controller method: App\Http\Controllers\Api\Tools\AlertController::store
  // URI: api/tools/alerts
  return axios.post(route("api.alerts.store", routeParams), body, config);
};

export const apiAlertsShow = (
  routeParams: {alert: string | number; [x: string]: unknown},
  config?: AxiosRequestConfig,
): Promise<
  AxiosResponse<{
    id: number;
    name: string;
    alert_after_minutes: number;
    use_business_hours: boolean;
    type: "external" | "internal" | "anybody";
    notify_types: Array<"all_agents" | "custom_emails">;
    custom_emails: string[];
    enabled: boolean;
    reply_to_operator: App.Enums.LogicalOperator;
    create_crm_tasks: boolean;
    selected_entities: App.DataObjects.ElasticsearchEntityObject[];
    selected_model: null;
    in_conversation: boolean;
    exclude_emails: string[];
    exclude_domains: string[];
  }>
> => {
  // Controller method: App\Http\Controllers\Api\Tools\AlertController::show
  // URI: api/tools/alerts/{alert}
  return axios.get(route("api.alerts.show", routeParams), config);
};

export const apiAlertsUpdate = (
  routeParams: {alert: string | number; [x: string]: unknown},
  body: App.Http.Requests.Tools.StoreAlertRequest,
  config?: AxiosRequestConfig,
): Promise<
  AxiosResponse<{
    id: number;
    name: string;
    alert_after_minutes: number;
    use_business_hours: boolean;
    type: "external" | "internal" | "anybody";
    notify_types: Array<"all_agents" | "custom_emails">;
    custom_emails: string[];
    enabled: boolean;
    reply_to_operator: App.Enums.LogicalOperator;
    create_crm_tasks: boolean;
    selected_entities: App.DataObjects.ElasticsearchEntityObject[];
    selected_model: null;
    in_conversation: boolean;
    exclude_emails: string[];
    exclude_domains: string[];
  }>
> => {
  // Controller method: App\Http\Controllers\Api\Tools\AlertController::update
  // URI: api/tools/alerts/{alert}
  return axios.put(route("api.alerts.update", routeParams), body, config);
};

export const apiAlertsDestroy = (routeParams: {alert: string | number; [x: string]: unknown}, config?: AxiosRequestConfig): Promise<AxiosResponse<App.DataObjects.TtrStatusResponse>> => {
  // Controller method: App\Http\Controllers\Api\Tools\AlertController::destroy
  // URI: api/tools/alerts/{alert}
  return axios.delete(route("api.alerts.destroy", routeParams), config);
};

export const apiMicrosoftProxyAddressesIndex = (
  routeParams?: App.Http.Requests.Tools.MicrosoftProxyAddressIndexRequest & {[x: string]: unknown},
  config?: AxiosRequestConfig,
): Promise<AxiosResponse<LaravelLengthAwarePaginator<App.Models.MicrosoftProxyAddress>>> => {
  // Controller method: App\Http\Controllers\Api\Tools\MicrosoftProxyAddressController::index
  // URI: api/tools/microsoft-proxy-addresses
  // @ts-ignore the below error is because ziggy does not know about the shape of the query params
  return axios.get(route("api.microsoft-proxy-addresses.index", routeParams), config);
};

export const apiMicrosoftProxyAddressesStore = (
  routeParams?: {[x: string]: unknown},
  body?: App.Http.Requests.Tools.MicrosoftProxyAddressStoreRequest,
  config?: AxiosRequestConfig,
): Promise<AxiosResponse<App.Models.MicrosoftProxyAddress>> => {
  // Controller method: App\Http\Controllers\Api\Tools\MicrosoftProxyAddressController::store
  // URI: api/tools/microsoft-proxy-addresses
  return axios.post(route("api.microsoft-proxy-addresses.store", routeParams), body, config);
};

export const apiMicrosoftProxyAddressesShow = (routeParams: {microsoft_proxy_address: string | number; [x: string]: unknown}, config?: AxiosRequestConfig): Promise<AxiosResponse<App.Models.MicrosoftProxyAddress>> => {
  // Controller method: App\Http\Controllers\Api\Tools\MicrosoftProxyAddressController::show
  // URI: api/tools/microsoft-proxy-addresses/{microsoft_proxy_address}
  return axios.get(route("api.microsoft-proxy-addresses.show", routeParams), config);
};

export const apiMicrosoftProxyAddressesUpdate = (
  routeParams: {microsoft_proxy_address: string | number; [x: string]: unknown},
  body: App.Http.Requests.Tools.MicrosoftProxyAddressUpdateRequest,
  config?: AxiosRequestConfig,
): Promise<AxiosResponse<App.Models.MicrosoftProxyAddress>> => {
  // Controller method: App\Http\Controllers\Api\Tools\MicrosoftProxyAddressController::update
  // URI: api/tools/microsoft-proxy-addresses/{microsoft_proxy_address}
  return axios.put(route("api.microsoft-proxy-addresses.update", routeParams), body, config);
};

export const apiMicrosoftProxyAddressesDestroy = (routeParams: {microsoft_proxy_address: string | number; [x: string]: unknown}, config?: AxiosRequestConfig): Promise<AxiosResponse<App.DataObjects.TtrStatusResponse>> => {
  // Controller method: App\Http\Controllers\Api\Tools\MicrosoftProxyAddressController::destroy
  // URI: api/tools/microsoft-proxy-addresses/{microsoft_proxy_address}
  return axios.delete(route("api.microsoft-proxy-addresses.destroy", routeParams), config);
};

export const apiCompanyInternalDomainsIndex = (
  routeParams?: App.Http.Requests.Tools.GetInternalDomainsRequest & {[x: string]: unknown},
  config?: AxiosRequestConfig,
): Promise<AxiosResponse<LaravelLengthAwarePaginator<App.Models.EmailDomain & {add_method: "manual" | "automatic"}>>> => {
  // Controller method: App\Http\Controllers\Api\Tools\CompanyController::getInternalDomains
  // URI: api/tools/company/internal-domains
  // @ts-ignore the below error is because ziggy does not know about the shape of the query params
  return axios.get(route("api.company.internal-domains.index", routeParams), config);
};

export const apiCompanyInternalDomainsStore = (
  routeParams?: {[x: string]: unknown},
  body?: App.Http.Requests.Tools.UpdateInternalDomainsRequest,
  config?: AxiosRequestConfig,
): Promise<AxiosResponse<LaravelLengthAwarePaginator<App.Models.EmailDomain & {add_method: "manual" | "automatic"}>>> => {
  // Controller method: App\Http\Controllers\Api\Tools\CompanyController::updateInternalDomains
  // URI: api/tools/company/internal-domains
  return axios.post(route("api.company.internal-domains.store", routeParams), body, config);
};

export const apiCompanyInternalDomainsDestroy = (routeParams: {internal_domain: string | number; [x: string]: unknown}, config?: AxiosRequestConfig): Promise<AxiosResponse<LaravelLengthAwarePaginator<App.Models.EmailDomain>>> => {
  // Controller method: App\Http\Controllers\Api\Tools\CompanyController::removeInternalDomains
  // URI: api/tools/company/internal-domains/{internal_domain}
  return axios.delete(route("api.company.internal-domains.destroy", routeParams), config);
};

export const apiCompanyConversationThreadingStyleUpdate = (
  routeParams?: {[x: string]: unknown},
  body?: App.Http.Requests.Tools.CompanySetConversationStyleRequest,
  config?: AxiosRequestConfig,
): Promise<AxiosResponse<App.DataObjects.TtrStatusResponse>> => {
  // Controller method: App\Http\Controllers\Api\Tools\CompanyController::setConversationStyle
  // URI: api/tools/company/conversation-threading-style
  return axios.post(route("api.company.conversation-threading-style.update", routeParams), body, config);
};

export const apiCompanyCloseConversationEmailsIndex = (
  routeParams?: App.Http.Requests.Tools.GetClosedEmailUsernamesRequest & {[x: string]: unknown},
  config?: AxiosRequestConfig,
): Promise<AxiosResponse<LaravelLengthAwarePaginator<App.Models.EmailUsername>>> => {
  // Controller method: App\Http\Controllers\Api\Tools\CompanyController::getClosedEmailUsernames
  // URI: api/tools/company/close-conversation-emails
  // @ts-ignore the below error is because ziggy does not know about the shape of the query params
  return axios.get(route("api.company.close-conversation-emails.index", routeParams), config);
};

export const apiCompanyCloseConversationEmailsStore = (
  routeParams?: {[x: string]: unknown},
  body?: App.Http.Requests.Tools.CompanyUpdateClosedEmailUsernamesRequest,
  config?: AxiosRequestConfig,
): Promise<AxiosResponse<LaravelLengthAwarePaginator<App.Models.EmailUsername>>> => {
  // Controller method: App\Http\Controllers\Api\Tools\CompanyController::updateClosedEmailUsernames
  // URI: api/tools/company/close-conversation-emails
  return axios.post(route("api.company.close-conversation-emails.store", routeParams), body, config);
};

export const apiCompanyCloseConversationEmailsDestroy = (routeParams: {email_username: string | number; [x: string]: unknown}, config?: AxiosRequestConfig): Promise<AxiosResponse<LaravelLengthAwarePaginator<App.Models.EmailUsername>>> => {
  // Controller method: App\Http\Controllers\Api\Tools\CompanyController::removeClosedEmailUsernames
  // URI: api/tools/company/close-conversation-emails/{email_username}
  return axios.delete(route("api.company.close-conversation-emails.destroy", routeParams), config);
};

export const apiCompanyPreferenceUpdate = (routeParams?: {[x: string]: unknown}, body?: App.Http.Requests.Tools.CompanyUpdatePreferenceRequest, config?: AxiosRequestConfig): Promise<AxiosResponse<App.DataObjects.TtrStatusResponse>> => {
  // Controller method: App\Http\Controllers\Api\Tools\CompanyController::updatePreference
  // URI: api/tools/company/update-preference
  return axios.patch(route("api.company.preference.update", routeParams), body, config);
};

export const apiBusinessHoursIndex = (routeParams?: App.Http.Requests.Tools.BusinessHoursIndexRequest & {[x: string]: unknown}, config?: AxiosRequestConfig): Promise<AxiosResponse<App.Models.BusinessHours[]>> => {
  // Controller method: App\Http\Controllers\Api\Tools\BusinessHoursController::index
  // URI: api/tools/company/business-hours
  // @ts-ignore the below error is because ziggy does not know about the shape of the query params
  return axios.get(route("api.business-hours.index", routeParams), config);
};

export const apiBusinessHoursStore = (routeParams?: {[x: string]: unknown}, body?: App.Http.Requests.Tools.BusinessHoursStoreRequest, config?: AxiosRequestConfig): Promise<AxiosResponse<App.Models.BusinessHours[]>> => {
  // Controller method: App\Http\Controllers\Api\Tools\BusinessHoursController::store
  // URI: api/tools/company/business-hours
  return axios.post(route("api.business-hours.store", routeParams), body, config);
};

export const apiBusinessHoursDestroy = (
  routeParams: App.Http.Requests.Tools.BusinessHoursDestroyRequest & {business_hour: string | number; [x: string]: unknown},
  config?: AxiosRequestConfig,
): Promise<AxiosResponse<App.Models.BusinessHours[]>> => {
  // Controller method: App\Http\Controllers\Api\Tools\BusinessHoursController::destroy
  // URI: api/tools/company/business-hours/{business_hour}
  // @ts-ignore the below error is because ziggy does not know about the shape of the query params
  return axios.delete(route("api.business-hours.destroy", routeParams), config);
};

export const apiCalendarSyncSettingsIndex = (
  routeParams?: App.Http.Requests.Tools.CalendarSyncSettingIndexRequest & {[x: string]: unknown},
  config?: AxiosRequestConfig,
): Promise<AxiosResponse<LaravelLengthAwarePaginator<App.Models.CalendarSyncSetting>>> => {
  // Controller method: App\Http\Controllers\Api\Tools\CalendarSyncSettingController::index
  // URI: api/tools/company/calendar-sync-settings
  // @ts-ignore the below error is because ziggy does not know about the shape of the query params
  return axios.get(route("api.calendar-sync-settings.index", routeParams), config);
};

export const apiCalendarSyncSettingsStore = (routeParams?: {[x: string]: unknown}, body?: App.Http.Requests.Tools.StoreCalendarSyncSettingRequest, config?: AxiosRequestConfig): Promise<AxiosResponse<App.Models.CalendarSyncSetting>> => {
  // Controller method: App\Http\Controllers\Api\Tools\CalendarSyncSettingController::store
  // URI: api/tools/company/calendar-sync-settings
  return axios.post(route("api.calendar-sync-settings.store", routeParams), body, config);
};

export const apiCalendarSyncSettingsUpdate = (
  routeParams: {calendar_sync_setting: string | number; [x: string]: unknown},
  body: App.Http.Requests.Tools.StoreCalendarSyncSettingRequest,
  config?: AxiosRequestConfig,
): Promise<AxiosResponse<App.Models.CalendarSyncSetting>> => {
  // Controller method: App\Http\Controllers\Api\Tools\CalendarSyncSettingController::update
  // URI: api/tools/company/calendar-sync-settings/{calendar_sync_setting}
  return axios.put(route("api.calendar-sync-settings.update", routeParams), body, config);
};

export const apiLeaveDaysStoreRange = (routeParams?: {[x: string]: unknown}, body?: App.Http.Requests.Tools.LeaveDayStoreRangeRequest, config?: AxiosRequestConfig): Promise<AxiosResponse<App.Models.LeaveDay[]>> => {
  // Controller method: App\Http\Controllers\Api\Tools\LeaveDayController::storeRange
  // URI: api/tools/company/leave-days/range
  return axios.post(route("api.leave-days.storeRange", routeParams), body, config);
};

export const apiLeaveDaysStore = (routeParams?: {[x: string]: unknown}, body?: App.Http.Requests.Tools.LeaveDayStoreRequest, config?: AxiosRequestConfig): Promise<AxiosResponse<App.Models.LeaveDay>> => {
  // Controller method: App\Http\Controllers\Api\Tools\LeaveDayController::store
  // URI: api/tools/company/leave-days
  return axios.post(route("api.leave-days.store", routeParams), body, config);
};

export const apiLeaveDaysDestroy = (
  routeParams: App.Http.Requests.Tools.LeaveDayDestroyRequest & {leave_day: string | number; [x: string]: unknown},
  config?: AxiosRequestConfig,
): Promise<AxiosResponse<App.DataObjects.TtrStatusResponse>> => {
  // Controller method: App\Http\Controllers\Api\Tools\LeaveDayController::destroy
  // URI: api/tools/company/leave-days/{leave_day}
  // @ts-ignore the below error is because ziggy does not know about the shape of the query params
  return axios.delete(route("api.leave-days.destroy", routeParams), config);
};

export const apiCompanyPagesPermissionsSave = (
  routeParams?: {[x: string]: unknown},
  body?: App.Http.Requests.Tools.CompanySavePagesPermissionsRequest,
  config?: AxiosRequestConfig,
): Promise<AxiosResponse<App.DataObjects.TtrStatusResponse>> => {
  // Controller method: App\Http\Controllers\Api\Tools\CompanyController::savePagesPermissions
  // URI: api/tools/company/pages-permissions
  return axios.post(route("api.company.pages-permissions.save", routeParams), body, config);
};

export const apiOptimizerSetupGet = (
  routeParams?: App.Http.Requests.Tools.OptimizerCriteriaGetOptimizerSettingsRequest & {[x: string]: unknown},
  config?: AxiosRequestConfig,
): Promise<AxiosResponse<App.DataObjects.OptimizerData.OptimizerSettingsOnlyData>> => {
  // Controller method: App\Http\Controllers\Api\Tools\OptimizerCriteriaController::getOptimizerSettings
  // URI: api/tools/company/optimizer/setup
  // @ts-ignore the below error is because ziggy does not know about the shape of the query params
  return axios.get(route("api.optimizer.setup.get", routeParams), config);
};

export const apiOptimizerSetupSave = (routeParams?: {[x: string]: unknown}, body?: App.Http.Requests.Tools.StoreOptimizerSettingsRequest, config?: AxiosRequestConfig): Promise<AxiosResponse<App.Models.NewOptimizerSettings>> => {
  // Controller method: App\Http\Controllers\Api\Tools\OptimizerCriteriaController::saveOptimizerSettings
  // URI: api/tools/company/optimizer/setup
  return axios.post(route("api.optimizer.setup.save", routeParams), body, config);
};

export const apiOptimizerSetupDestroy = (routeParams: {agent: string | number; [x: string]: unknown}, config?: AxiosRequestConfig): Promise<AxiosResponse<string>> => {
  // Controller method: App\Http\Controllers\Api\Tools\OptimizerCriteriaController::destroyOptimizerSettingsForAgent
  // URI: api/tools/company/optimizer/setup/{agent}
  return axios.delete(route("api.optimizer.setup.destroy", routeParams), config);
};

export const apiOptimizerAgentPreview = (
  routeParams?: App.Http.Requests.Tools.OptimizerCriteriaGetAgentFromRequestRequest & {[x: string]: unknown},
  config?: AxiosRequestConfig,
): Promise<AxiosResponse<App.DataObjects.OptimizerData.OptimizerGetInfoSuccessResponse>> => {
  // Controller method: App\Http\Controllers\Api\Tools\OptimizerCriteriaController::optimizerAgentPreview
  // URI: api/tools/company/optimizer/agent-preview
  // @ts-ignore the below error is because ziggy does not know about the shape of the query params
  return axios.get(route("api.optimizer.agent-preview", routeParams), config);
};

export const apiOptimizerGetMessageIdFromProviderId = (
  routeParams?: App.Http.Requests.Tools.OptimizerCriteriaOptimizerGetMessageIdFromProviderIdRequest & {[x: string]: unknown},
  config?: AxiosRequestConfig,
): Promise<AxiosResponse<string>> => {
  // Controller method: App\Http\Controllers\Api\Tools\OptimizerCriteriaController::optimizerGetMessageIdFromProviderId
  // URI: api/tools/company/optimizer/get-message-id-from-provider-id
  // @ts-ignore the below error is because ziggy does not know about the shape of the query params
  return axios.get(route("api.optimizer.get-message-id-from-provider-id", routeParams), config);
};

export const apiOptimizerStatLog = (
  routeParams?: App.Http.Requests.Tools.OptimizerCriteriaOptimizerStatLogRequest & {[x: string]: unknown},
  config?: AxiosRequestConfig,
): Promise<AxiosResponse<App.DataObjects.OptimizerData.OptimizerStatLogsResponse>> => {
  // Controller method: App\Http\Controllers\Api\Tools\OptimizerCriteriaController::optimizerStatLog
  // URI: api/tools/company/optimizer/stat-log
  // @ts-ignore the below error is because ziggy does not know about the shape of the query params
  return axios.get(route("api.optimizer.stat-log", routeParams), config);
};

export const apiOptimizerGetPossibleAssignees = (
  routeParams?: App.Http.Requests.Tools.OptimizerCriteriaOptimizerGetPossibleAssigneesRequest & {[x: string]: unknown},
  config?: AxiosRequestConfig,
): Promise<AxiosResponse<Array<PossibleAssignee>>> => {
  // Controller method: App\Http\Controllers\Api\Tools\OptimizerCriteriaController::optimizerGetPossibleAssignees
  // URI: api/tools/company/optimizer/get-possible-assignees
  // @ts-ignore the below error is because ziggy does not know about the shape of the query params
  return axios.get(route("api.optimizer.get-possible-assignees", routeParams), config);
};

export const apiOptimizerAssignMessage = (
  routeParams?: {[x: string]: unknown},
  body?: App.Http.Requests.Tools.OptimizerCriteriaOptimizerAssignMessageRequest,
  config?: AxiosRequestConfig,
): Promise<AxiosResponse<App.DataObjects.OptimizerData.OptimizerMessageData>> => {
  // Controller method: App\Http\Controllers\Api\Tools\OptimizerCriteriaController::optimizerAssignMessage
  // URI: api/tools/company/optimizer/assign-message
  return axios.post(route("api.optimizer.assign-message", routeParams), body, config);
};

export const apiOptimizerUnassignMessage = (
  routeParams?: App.Http.Requests.Tools.OptimizerCriteriaOptimizerUnassignMessageRequest & {[x: string]: unknown},
  config?: AxiosRequestConfig,
): Promise<AxiosResponse<App.DataObjects.OptimizerData.OptimizerMessageData>> => {
  // Controller method: App\Http\Controllers\Api\Tools\OptimizerCriteriaController::optimizerUnassignMessage
  // URI: api/tools/company/optimizer/unassign-message
  // @ts-ignore the below error is because ziggy does not know about the shape of the query params
  return axios.delete(route("api.optimizer.unassign-message", routeParams), config);
};

export const apiOptimizerSnooze = (
  routeParams?: {[x: string]: unknown},
  body?: App.Http.Requests.Tools.OptimizerCriteriaOptimizerSnoozeRequest,
  config?: AxiosRequestConfig,
): Promise<AxiosResponse<App.DataObjects.OptimizerData.OptimizerMessageData>> => {
  // Controller method: App\Http\Controllers\Api\Tools\OptimizerCriteriaController::optimizerSnooze
  // URI: api/tools/company/optimizer/snooze
  return axios.post(route("api.optimizer.snooze", routeParams), body, config);
};

export const apiOptimizerHide = (
  routeParams?: {[x: string]: unknown},
  body?: App.Http.Requests.Tools.OptimizerCriteriaOptimizerHideRequest,
  config?: AxiosRequestConfig,
): Promise<AxiosResponse<App.DataObjects.OptimizerData.OptimizerMessageData>> => {
  // Controller method: App\Http\Controllers\Api\Tools\OptimizerCriteriaController::optimizerHide
  // URI: api/tools/company/optimizer/hide
  return axios.post(route("api.optimizer.hide", routeParams), body, config);
};

export const apiOptimizerUpdateThreadStatus = (
  routeParams?: {[x: string]: unknown},
  body?: App.Http.Requests.Tools.OptimizerCriteriaOptimizerUpdateThreadStatusRequest,
  config?: AxiosRequestConfig,
): Promise<AxiosResponse<App.DataObjects.OptimizerData.OptimizerMessageData>> => {
  // Controller method: App\Http\Controllers\Api\Tools\OptimizerCriteriaController::optimizerUpdateThreadStatus
  // URI: api/tools/company/optimizer/update-thread-status
  return axios.post(route("api.optimizer.update-thread-status", routeParams), body, config);
};

export const apiOptimizerCriteriaIndex = (
  routeParams?: App.Http.Requests.Tools.OptimizerCriteriaIndexRequest & {[x: string]: unknown},
  config?: AxiosRequestConfig,
): Promise<AxiosResponse<LaravelLengthAwarePaginator<App.Models.OptimizerCriteria>>> => {
  // Controller method: App\Http\Controllers\Api\Tools\OptimizerCriteriaController::index
  // URI: api/tools/company/optimizer-criteria
  // @ts-ignore the below error is because ziggy does not know about the shape of the query params
  return axios.get(route("api.optimizer-criteria.index", routeParams), config);
};

export const apiOptimizerCriteriaStore = (routeParams?: {[x: string]: unknown}, body?: App.Http.Requests.Tools.StoreOptimizerCriteriaRequest, config?: AxiosRequestConfig): Promise<AxiosResponse<App.Models.OptimizerCriteria>> => {
  // Controller method: App\Http\Controllers\Api\Tools\OptimizerCriteriaController::store
  // URI: api/tools/company/optimizer-criteria
  return axios.postForm(route("api.optimizer-criteria.store", routeParams), body, config);
};

export const apiOptimizerCriteriaUpdate = (
  routeParams: {optimizer_criteria: string | number; [x: string]: unknown},
  body: App.Http.Requests.Tools.StoreOptimizerCriteriaRequest,
  config?: AxiosRequestConfig,
): Promise<AxiosResponse<App.Models.OptimizerCriteria>> => {
  // Controller method: App\Http\Controllers\Api\Tools\OptimizerCriteriaController::update
  // URI: api/tools/company/optimizer-criteria/{optimizer_criteria}
  // @ts-ignore
  body._method = "PATCH";
  return axios.postForm(route("api.optimizer-criteria.update", routeParams), body, config);
};

export const apiOptimizerCriteriaDestroy = (routeParams: {optimizer_criteria: string | number; [x: string]: unknown}, config?: AxiosRequestConfig): Promise<AxiosResponse<App.DataObjects.TtrStatusResponse>> => {
  // Controller method: App\Http\Controllers\Api\Tools\OptimizerCriteriaController::destroy
  // URI: api/tools/company/optimizer-criteria/{optimizer_criteria}
  return axios.delete(route("api.optimizer-criteria.destroy", routeParams), config);
};

export const apiUsersInvite = (routeParams?: {[x: string]: unknown}, body?: App.Http.Requests.Tools.CompanySendUserInviteRequest, config?: AxiosRequestConfig): Promise<AxiosResponse<App.DataObjects.TtrStatusResponse>> => {
  // Controller method: App\Http\Controllers\Api\Tools\CompanyController::sendUserInvite
  // URI: api/tools/users/invite-user
  return axios.post(route("api.users.invite", routeParams), body, config);
};

export const apiUsersInviteResend = (routeParams: {user_invite: string | number; [x: string]: unknown}, body: any, config?: AxiosRequestConfig): Promise<AxiosResponse<App.DataObjects.TtrStatusResponse>> => {
  // Controller method: App\Http\Controllers\Api\Tools\CompanyController::resendUserInvite
  // URI: api/tools/users/invite-user/{user_invite}
  return axios.post(route("api.users.invite.resend", routeParams), body, config);
};

export const apiUsersInviteDestroy = (routeParams: {user_invite: string | number; [x: string]: unknown}, config?: AxiosRequestConfig): Promise<AxiosResponse<App.DataObjects.TtrStatusResponse>> => {
  // Controller method: App\Http\Controllers\Api\Tools\CompanyController::destroyUserInvite
  // URI: api/tools/users/invite-user/{user_invite}
  return axios.delete(route("api.users.invite.destroy", routeParams), config);
};

export const apiRolesIndex = (routeParams?: {[x: string]: unknown}, config?: AxiosRequestConfig): Promise<AxiosResponse<App.Models.Role[]>> => {
  // Controller method: App\Http\Controllers\Api\Tools\CompanyController::getRoles
  // URI: api/tools/users/roles
  return axios.get(route("api.roles.index", routeParams), config);
};

export const apiUserInviteAgents = (routeParams?: {[x: string]: unknown}, body?: App.Http.Requests.Tools.CompanyInviteAgentsAsUserRequest, config?: AxiosRequestConfig): Promise<AxiosResponse<number[]>> => {
  // Controller method: App\Http\Controllers\Api\Tools\CompanyController::inviteAgentsAsUser
  // URI: api/tools/users/invite-as-users
  return axios.post(route("api.user.invite-agents", routeParams), body, config);
};

export const apiCompanyUsersShow = (
  routeParams: {user: string | number; [x: string]: unknown},
  config?: AxiosRequestConfig,
): Promise<
  AxiosResponse<{
    id: number;
    firstname: string;
    lastname: string;
    email: string;
    phone: string | null;
    country_code: string | null;
    active: boolean;
    company_id: number;
    created_at: string;
    updated_at: string;
    last_login_at: string | null;
    last_login_ip: string | null;
    provider: string | null;
    provider_id: string | null;
    is_primary_user: boolean;
    complete_name: string;
    php_time_zone: string;
    company: string;
    timezone: string;
    role: "System Administrator" | "Company Administrator" | "Company Manager" | "Restricted Manager" | "Company Agent" | "System Reseller";
    agentPermissions: Record<number, string>;
    groupPermissions: Record<number, string>;
    teamPermissions: Record<number, string>;
    customerGroupPermissions: Record<number, string>;
  }>
> => {
  // Controller method: App\Http\Controllers\Api\Tools\CompanyController::getUser
  // URI: api/tools/users/{user}
  return axios.get(route("api.company.users.show", routeParams), config);
};

export const apiCompanyUsersUpdate = (
  routeParams: {user: string | number; [x: string]: unknown},
  body: App.Http.Requests.Tools.CompanyEditUserRequest,
  config?: AxiosRequestConfig,
): Promise<
  AxiosResponse<{
    id: number;
    firstname: string;
    lastname: string;
    email: string;
    phone: string | null;
    country_code: string | null;
    active: boolean;
    company_id: number;
    created_at: string;
    updated_at: string;
    last_login_at: string | null;
    last_login_ip: string | null;
    provider: string | null;
    provider_id: string | null;
    is_primary_user: boolean;
    complete_name: string;
    php_time_zone: string;
    company: string;
    timezone: string;
    role: "System Administrator" | "Company Administrator" | "Company Manager" | "Restricted Manager" | "Company Agent" | "System Reseller";
    agentPermissions: Record<number, string>;
    groupPermissions: Record<number, string>;
    teamPermissions: Record<number, string>;
    customerGroupPermissions: Record<number, string>;
  }>
> => {
  // Controller method: App\Http\Controllers\Api\Tools\CompanyController::editUser
  // URI: api/tools/users/{user}
  return axios.patch(route("api.company.users.update", routeParams), body, config);
};

export const apiUserDestroy = (routeParams: {user: string | number; [x: string]: unknown}, config?: AxiosRequestConfig): Promise<AxiosResponse<App.DataObjects.TtrStatusResponse>> => {
  // Controller method: App\Http\Controllers\Api\Tools\CompanyController::removeUser
  // URI: api/tools/users/{user}
  return axios.delete(route("api.user.destroy", routeParams), config);
};

export const apiCompanyUsersIndex = (routeParams?: App.Http.Requests.Tools.CompanyUsersIndexRequest & {[x: string]: unknown}, config?: AxiosRequestConfig): Promise<AxiosResponse<LaravelLengthAwarePaginator<App.Models.User>>> => {
  // Controller method: App\Http\Controllers\Api\Tools\CompanyUsersController::index
  // URI: api/tools/users
  // @ts-ignore the below error is because ziggy does not know about the shape of the query params
  return axios.get(route("api.company.users.index", routeParams), config);
};

export const apiPromptTrackingActionsSave = (routeParams?: {[x: string]: unknown}, body?: App.Http.Requests.Tools.PromptTrackingActionSaveActionRequest, config?: AxiosRequestConfig): Promise<AxiosResponse<{message: string}>> => {
  // Controller method: App\Http\Controllers\Api\Tools\PromptTrackingActionController::saveAction
  // URI: api/tools/prompt-tracking-action/save
  return axios.post(route("api.prompt-tracking-actions.save", routeParams), body, config);
};

export const apiOptimizerInvitationSendInstructionsToItAdmin = (
  routeParams?: {[x: string]: unknown},
  body?: App.Http.Requests.Tools.OptimizerInvitationSendInstructionsToItAdminRequest,
  config?: AxiosRequestConfig,
): Promise<AxiosResponse<string>> => {
  // Controller method: App\Http\Controllers\Api\Tools\OptimizerInvitationController::sendInstructionsToItAdmin
  // URI: api/tools/optimizer-invitation/send-instructions-to-it-admin
  return axios.post(route("api.optimizer-invitation.send-instructions-to-it-admin", routeParams), body, config);
};

export const apiOptimizerInvitationSendInvitationToMailboxes = (
  routeParams?: {[x: string]: unknown},
  body?: App.Http.Requests.Tools.OptimizerInvitationSendInvitationToMailboxesRequest,
  config?: AxiosRequestConfig,
): Promise<AxiosResponse<string>> => {
  // Controller method: App\Http\Controllers\Api\Tools\OptimizerInvitationController::sendInvitationToMailboxes
  // URI: api/tools/optimizer-invitation/send-invitation-to-mailboxes
  return axios.post(route("api.optimizer-invitation.send-invitation-to-mailboxes", routeParams), body, config);
};

export const apiThreadsIndex = (routeParams?: App.Http.Requests.Reports.GetReportDataRequest & {[x: string]: unknown}, config?: AxiosRequestConfig): Promise<AxiosResponse<App.DataObjects.ReportResponses.ConversationLogsResponseData>> => {
  // Controller method: App\Http\Controllers\Api\Logs\ConversationLogController::index
  // URI: api/logs/conversations
  // @ts-ignore the below error is because ziggy does not know about the shape of the query params
  return axios.get(route("api.threads.index", routeParams), config);
};

export const apiThreadsGetBySubjectOrEmail = (routeParams?: App.Http.Requests.Logs.ConversationLogGetBySubjectOrEmailRequest & {[x: string]: unknown}, config?: AxiosRequestConfig): Promise<AxiosResponse<{id: number; name: string}[]>> => {
  // Controller method: App\Http\Controllers\Api\Logs\ConversationLogController::getBySubjectOrEmail
  // URI: api/logs/conversations/get-by-subject-or-email
  // @ts-ignore the below error is because ziggy does not know about the shape of the query params
  return axios.get(route("api.threads.get-by-subject-or-email", routeParams), config);
};

export const apiThreadsGetByInternetMessageId = (
  routeParams?: App.Http.Requests.Logs.ConversationLogGetByInternetMessageIdRequest & {[x: string]: unknown},
  config?: AxiosRequestConfig,
): Promise<AxiosResponse<App.DataObjects.ElasticsearchThreadData>> => {
  // Controller method: App\Http\Controllers\Api\Logs\ConversationLogController::getByInternetMessageId
  // URI: api/logs/conversations/get-by-internet-message-id
  // @ts-ignore the below error is because ziggy does not know about the shape of the query params
  return axios.get(route("api.threads.get-by-internet-message-id", routeParams), config);
};

export const apiThreadsMarkClosed = (routeParams?: {[x: string]: unknown}, body?: App.Http.Requests.Logs.ConversationLogMarkAsClosedRequest, config?: AxiosRequestConfig): Promise<AxiosResponse<{ids: number[]}>> => {
  // Controller method: App\Http\Controllers\Api\Logs\ConversationLogController::markAsClosed
  // URI: api/logs/conversations/mark-closed
  return axios.post(route("api.threads.mark-closed", routeParams), body, config);
};

export const apiThreadsExcludeFromSlaBreach = (routeParams?: {[x: string]: unknown}, body?: App.Http.Requests.Logs.ManuallyExcludedFromSlaBreachStoreThreadsRequest, config?: AxiosRequestConfig): Promise<AxiosResponse<{ids: number[]}>> => {
  // Controller method: App\Http\Controllers\Api\Logs\ManuallyExcludedFromSlaBreachController::storeThreads
  // URI: api/logs/conversations/exclude-from-sla-breach
  return axios.post(route("api.threads.exclude-from-sla-breach", routeParams), body, config);
};

export const apiThreadsRemoveExcludeFromSlaBreach = (
  routeParams?: {[x: string]: unknown},
  body?: App.Http.Requests.Logs.ManuallyExcludedFromSlaBreachRemoveThreadsRequest,
  config?: AxiosRequestConfig,
): Promise<AxiosResponse<{ids: number[]}>> => {
  // Controller method: App\Http\Controllers\Api\Logs\ManuallyExcludedFromSlaBreachController::removeThreads
  // URI: api/logs/conversations/remove-exclude-from-sla-breach
  return axios.post(route("api.threads.remove-exclude-from-sla-breach", routeParams), body, config);
};

export const apiMessagesIndex = (routeParams?: App.Http.Requests.Reports.GetReportDataRequest & {[x: string]: unknown}, config?: AxiosRequestConfig): Promise<AxiosResponse<App.DataObjects.ReportResponses.MessageLogsResponseData>> => {
  // Controller method: App\Http\Controllers\Api\Logs\MessageLogController::index
  // URI: api/logs/messages
  // @ts-ignore the below error is because ziggy does not know about the shape of the query params
  return axios.get(route("api.messages.index", routeParams), config);
};

export const apiMessagesExcludeFromSlaBreach = (
  routeParams?: {[x: string]: unknown},
  body?: App.Http.Requests.Logs.ManuallyExcludedFromSlaBreachStoreMessagesRequest,
  config?: AxiosRequestConfig,
): Promise<AxiosResponse<{ids: string[]}>> => {
  // Controller method: App\Http\Controllers\Api\Logs\ManuallyExcludedFromSlaBreachController::storeMessages
  // URI: api/logs/messages/exclude-from-sla-breach
  return axios.post(route("api.messages.exclude-from-sla-breach", routeParams), body, config);
};

export const apiMessagesRemoveExcludeFromSlaBreach = (
  routeParams?: {[x: string]: unknown},
  body?: App.Http.Requests.Logs.ManuallyExcludedFromSlaBreachRemoveMessagesRequest,
  config?: AxiosRequestConfig,
): Promise<AxiosResponse<{ids: string[]}>> => {
  // Controller method: App\Http\Controllers\Api\Logs\ManuallyExcludedFromSlaBreachController::removeMessages
  // URI: api/logs/messages/remove-exclude-from-sla-breach
  return axios.post(route("api.messages.remove-exclude-from-sla-breach", routeParams), body, config);
};

export const apiThreadsExport = (routeParams?: {[x: string]: unknown}, config?: AxiosRequestConfig): Promise<AxiosResponse<{data: any}>> => {
  // Controller method: App\Http\Controllers\Api\Logs\ConversationLogController::exportForZapier
  // URI: api/logs/conversations-export
  return axios.get(route("api.threads.export", routeParams), config);
};

export const apiMessagesExport = (routeParams?: {[x: string]: unknown}, config?: AxiosRequestConfig): Promise<AxiosResponse<{data: any}>> => {
  // Controller method: App\Http\Controllers\Api\Logs\MessageLogController::exportForZapier
  // URI: api/logs/messages-export
  return axios.get(route("api.messages.export", routeParams), config);
};

export const apiAuditLogsIndex = (routeParams?: App.Http.Requests.Logs.GetAuditLogsRequest & {[x: string]: unknown}, config?: AxiosRequestConfig): Promise<AxiosResponse<{logs: LaravelLengthAwarePaginator<AuditEntry>}>> => {
  // Controller method: App\Http\Controllers\Api\Logs\AuditLogController::index
  // URI: api/logs/audits
  // @ts-ignore the below error is because ziggy does not know about the shape of the query params
  return axios.get(route("api.audit-logs.index", routeParams), config);
};

export const apiStatBreakdownIndex = (routeParams?: App.Http.Requests.Reports.GetReportDataRequest & {[x: string]: unknown}, config?: AxiosRequestConfig): Promise<AxiosResponse<App.DataObjects.ReportResponses.StatLogResponseData>> => {
  // Controller method: App\Http\Controllers\Api\Logs\StatLogController::index
  // URI: api/logs/stat-breakdown
  // @ts-ignore the below error is because ziggy does not know about the shape of the query params
  return axios.get(route("api.stat-breakdown.index", routeParams), config);
};

export const apiSetupOptions = (routeParams?: App.Http.Requests.Reports.SetupGetAllowedRequest & {[x: string]: unknown}, config?: AxiosRequestConfig): Promise<AxiosResponse<any[]>> => {
  // Controller method: App\Http\Controllers\Api\Reports\SetupController::getAllowed
  // URI: api/reports/setupOptions
  // @ts-ignore the below error is because ziggy does not know about the shape of the query params
  return axios.get(route("api.setup.options", routeParams), config);
};

export const apiSetupUpdate = (
  routeParams?: {[x: string]: unknown},
  body?: App.Http.Requests.Reports.SetupUpdateRequest,
  config?: AxiosRequestConfig,
): Promise<
  AxiosResponse<
    | App.DataObjects.Widgets.TrendWidgetInterface[]
    | App.DataObjects.Widgets.TableBasedReportWidgetInterface[]
    | Record<
        BreakPoint,
        {
          beta: boolean;
          expanded: boolean;
          h: number;
          name: string;
          static: boolean;
          w: number;
          x: number;
          y: number;
          type: string;
          options: {
            columns?: Record<
              string,
              {
                field: string;
                sortable: boolean;
                centered: boolean;
                label: string;
                visible: boolean;
                hasComparison: boolean;
                group: string;
                flipColors?: boolean;
                hasEmails?: boolean;
                headerClass?: string;
                hasGoals?: boolean;
                tooltip?: string;
              }
            >;
          };
        }[]
      >
  >
> => {
  // Controller method: App\Http\Controllers\Api\Reports\SetupController::update
  // URI: api/reports/setup
  return axios.post(route("api.setup.update", routeParams), body, config);
};

export const apiReportsOverviewIndex = (
  routeParams?: App.Http.Requests.Reports.GetReportDataRequest & {[x: string]: unknown},
  config?: AxiosRequestConfig,
): Promise<AxiosResponse<App.DataObjects.ReportResponses.OverviewSlaReportResponseData>> => {
  // Controller method: App\Http\Controllers\Api\Reports\OverviewController::index
  // URI: api/reports/overview
  // @ts-ignore the below error is because ziggy does not know about the shape of the query params
  return axios.get(route("api.reports.overview.index", routeParams), config);
};

export const apiReportsOverviewExport = (routeParams?: {[x: string]: unknown}, config?: AxiosRequestConfig): Promise<AxiosResponse<{data: any}>> => {
  // Controller method: App\Http\Controllers\Api\Reports\OverviewController::exportForZapier
  // URI: api/reports/overview-export
  return axios.get(route("api.reports.overview.export", routeParams), config);
};

export const apiReportsProductivityIndex = (
  routeParams?: App.Http.Requests.Reports.GetReportDataRequest & {[x: string]: unknown},
  config?: AxiosRequestConfig,
): Promise<AxiosResponse<App.DataObjects.ReportResponses.ProductivityReportResponseData>> => {
  // Controller method: App\Http\Controllers\Api\Reports\ProductivityController::index
  // URI: api/reports/productivity
  // @ts-ignore the below error is because ziggy does not know about the shape of the query params
  return axios.get(route("api.reports.productivity.index", routeParams), config);
};

export const apiReportsComparativeIndex = (
  routeParams?: App.Http.Requests.Reports.GetReportDataRequest & {[x: string]: unknown},
  config?: AxiosRequestConfig,
): Promise<AxiosResponse<App.DataObjects.ReportResponses.ComparativeReportResponseData>> => {
  // Controller method: App\Http\Controllers\Api\Reports\ComparativeController::index
  // URI: api/reports/comparative
  // @ts-ignore the below error is because ziggy does not know about the shape of the query params
  return axios.get(route("api.reports.comparative.index", routeParams), config);
};

export const apiReportsInteractionsIndex = (
  routeParams?: App.Http.Requests.Reports.GetReportDataRequest & {[x: string]: unknown},
  config?: AxiosRequestConfig,
): Promise<AxiosResponse<{[key: string]: App.DataObjects.ReportResponses.Stats.InteractionsAgentData}>> => {
  // Controller method: App\Http\Controllers\Api\Reports\InteractionsController::index
  // URI: api/reports/interactions
  // @ts-ignore the below error is because ziggy does not know about the shape of the query params
  return axios.get(route("api.reports.interactions.index", routeParams), config);
};

export const apiReportsSlaIndex = (
  routeParams?: App.Http.Requests.Reports.GetReportDataRequest & {[x: string]: unknown},
  config?: AxiosRequestConfig,
): Promise<AxiosResponse<App.DataObjects.ReportResponses.OverviewSlaReportResponseData>> => {
  // Controller method: App\Http\Controllers\Api\Reports\SlaController::index
  // URI: api/reports/sla
  // @ts-ignore the below error is because ziggy does not know about the shape of the query params
  return axios.get(route("api.reports.sla.index", routeParams), config);
};

export const apiReportsTrendIndex = (routeParams?: App.Http.Requests.Reports.GetReportDataRequest & {[x: string]: unknown}, config?: AxiosRequestConfig): Promise<AxiosResponse<App.DataObjects.ReportResponses.TrendReportResponseData>> => {
  // Controller method: App\Http\Controllers\Api\Reports\TrendController::index
  // URI: api/reports/trend
  // @ts-ignore the below error is because ziggy does not know about the shape of the query params
  return axios.get(route("api.reports.trend.index", routeParams), config);
};

export const apiReportsContactIndex = (
  routeParams?: App.Http.Requests.Reports.GetReportDataRequest & {[x: string]: unknown},
  config?: AxiosRequestConfig,
): Promise<AxiosResponse<App.DataObjects.ReportResponses.ContactReportResponseData>> => {
  // Controller method: App\Http\Controllers\Api\Reports\CustomerReportController::index
  // URI: api/reports/contact
  // @ts-ignore the below error is because ziggy does not know about the shape of the query params
  return axios.get(route("api.reports.contact.index", routeParams), config);
};

export const apiReportsContactExport = (routeParams?: {[x: string]: unknown}, config?: AxiosRequestConfig): Promise<AxiosResponse<{data: any}>> => {
  // Controller method: App\Http\Controllers\Api\Reports\CustomerReportController::exportForZapier
  // URI: api/reports/contact-export
  return axios.get(route("api.reports.contact.export", routeParams), config);
};

export const apiReportsTeamsIndex = (routeParams?: App.Http.Requests.Reports.GetReportDataRequest & {[x: string]: unknown}, config?: AxiosRequestConfig): Promise<AxiosResponse<App.DataObjects.ReportResponses.TeamsReportResponseData>> => {
  // Controller method: App\Http\Controllers\Api\Reports\TeamsReportController::index
  // URI: api/reports/teams
  // @ts-ignore the below error is because ziggy does not know about the shape of the query params
  return axios.get(route("api.reports.teams.index", routeParams), config);
};

export const apiReportsGroupMailboxesIndex = (
  routeParams?: App.Http.Requests.Reports.GetReportDataRequest & {[x: string]: unknown},
  config?: AxiosRequestConfig,
): Promise<AxiosResponse<App.DataObjects.ReportResponses.GroupMailboxesReportResponseData>> => {
  // Controller method: App\Http\Controllers\Api\Reports\GroupMailboxesReportController::index
  // URI: api/reports/group-mailboxes
  // @ts-ignore the below error is because ziggy does not know about the shape of the query params
  return axios.get(route("api.reports.group-mailboxes.index", routeParams), config);
};

export const apiReportsLeadSourcesIndex = (
  routeParams?: App.Http.Requests.Reports.GetReportDataRequest & {[x: string]: unknown},
  config?: AxiosRequestConfig,
): Promise<AxiosResponse<App.DataObjects.ReportResponses.Ignite.LeadSourcesReportResponseData>> => {
  // Controller method: App\Http\Controllers\Api\Ignite\Reports\LeadSourcesReportController::index
  // URI: api/reports/lead-sources
  // @ts-ignore the below error is because ziggy does not know about the shape of the query params
  return axios.get(route("api.reports.lead-sources.index", routeParams), config);
};

export const apiReportsSalesRepIndex = (
  routeParams?: App.Http.Requests.Reports.GetReportDataRequest & {[x: string]: unknown},
  config?: AxiosRequestConfig,
): Promise<AxiosResponse<LaravelLengthAwarePaginator<App.DataObjects.ReportResponses.Ignite.Stats.SalesRepStat>>> => {
  // Controller method: App\Http\Controllers\Api\Ignite\Reports\SalesRepReportController::index
  // URI: api/reports/sales-rep
  // @ts-ignore the below error is because ziggy does not know about the shape of the query params
  return axios.get(route("api.reports.sales-rep.index", routeParams), config);
};

export const apiReportsSalesRepExport = (routeParams?: {[x: string]: unknown}, config?: AxiosRequestConfig): Promise<AxiosResponse<{data: any}>> => {
  // Controller method: App\Http\Controllers\Api\Ignite\Reports\SalesRepReportController::exportForZapier
  // URI: api/reports/sales-rep-export
  return axios.get(route("api.reports.sales-rep.export", routeParams), config);
};

export const apiReportsRequest = (routeParams?: {[x: string]: unknown}, body?: App.Http.Requests.Reports.ReportDownloadRequestRequest, config?: AxiosRequestConfig): Promise<AxiosResponse<App.DataObjects.TtrSuccessResponse>> => {
  // Controller method: App\Http\Controllers\Api\Reports\ReportDownloadController::request
  // URI: api/reports/request
  return axios.post(route("api.reports.request", routeParams), body, config);
};

export const apiMe = (routeParams?: {[x: string]: unknown}, config?: AxiosRequestConfig): Promise<AxiosResponse<{id: number; name: string; email: string}>> => {
  // Controller method: App\Http\Controllers\Api\Tools\ProfileController::me
  // URI: api/me
  return axios.get(route("api.me", routeParams), config);
};

export const apiPhoneSave = (routeParams?: {[x: string]: unknown}, body?: App.Http.Requests.Auth.SavePhoneNumberRequest, config?: AxiosRequestConfig): Promise<AxiosResponse<App.DataObjects.TtrStatusResponse>> => {
  // Controller method: App\Http\Controllers\Api\Auth\VerifyPhoneController::savePhoneNumber
  // URI: api/phone/save
  return axios.post(route("api.phone.save", routeParams), body, config);
};

export const apiPhoneVerify = (routeParams?: {[x: string]: unknown}, body?: App.Http.Requests.Auth.VerifyPhoneNumberRequest, config?: AxiosRequestConfig): Promise<AxiosResponse<App.DataObjects.TtrStatusResponse>> => {
  // Controller method: App\Http\Controllers\Api\Auth\VerifyPhoneController::verify
  // URI: api/phone/verify
  return axios.post(route("api.phone.verify", routeParams), body, config);
};

export const apiHooksSubscribe = (routeParams?: {[x: string]: unknown}, body?: App.Http.Requests.RestHooksSubscribeRequest, config?: AxiosRequestConfig): Promise<AxiosResponse<App.Models.Webhook>> => {
  // Controller method: App\Http\Controllers\Api\RestHooksController::subscribe
  // URI: api/hooks
  return axios.post(route("api.hooks.subscribe", routeParams), body, config);
};

export const apiHooksUnsubscribe = (routeParams: {webhook: string | number; [x: string]: unknown}, config?: AxiosRequestConfig): Promise<AxiosResponse<App.DataObjects.TtrSuccessResponse>> => {
  // Controller method: App\Http\Controllers\Api\RestHooksController::unsubscribe
  // URI: api/hooks/{webhook}
  return axios.delete(route("api.hooks.unsubscribe", routeParams), config);
};

export const apiHooksSamplesOverview = (routeParams?: {[x: string]: unknown}, config?: AxiosRequestConfig): Promise<AxiosResponse<App.DataObjects.OverviewReportDataSummary>> => {
  // Controller method: App\Http\Controllers\Api\RestHooksSamplesController::overviewReport
  // URI: api/hooks/samples/overviewReport
  return axios.get(route("api.hooks.samples.overview", routeParams), config);
};

export const apiHooksSamplesProductivity = (routeParams?: {[x: string]: unknown}, config?: AxiosRequestConfig): Promise<AxiosResponse<App.DataObjects.ProductivityReportDataSummary>> => {
  // Controller method: App\Http\Controllers\Api\RestHooksSamplesController::productivityReport
  // URI: api/hooks/samples/productivityReport
  return axios.get(route("api.hooks.samples.productivity", routeParams), config);
};

export const apiHooksSamplesComparative = (routeParams?: {[x: string]: unknown}, config?: AxiosRequestConfig): Promise<AxiosResponse<App.DataObjects.ComparativeReportDataSummary>> => {
  // Controller method: App\Http\Controllers\Api\RestHooksSamplesController::comparativeReport
  // URI: api/hooks/samples/comparativeReport
  return axios.get(route("api.hooks.samples.comparative", routeParams), config);
};

export const apiHooksSamplesInteractions = (routeParams?: {[x: string]: unknown}, config?: AxiosRequestConfig): Promise<AxiosResponse<{[key: string]: App.DataObjects.ReportResponses.Stats.InteractionsAgentData}>> => {
  // Controller method: App\Http\Controllers\Api\RestHooksSamplesController::interactionsReport
  // URI: api/hooks/samples/interactionsReport
  return axios.get(route("api.hooks.samples.interactions", routeParams), config);
};

export const apiHooksSamplesSla = (routeParams?: {[x: string]: unknown}, config?: AxiosRequestConfig): Promise<AxiosResponse<App.DataObjects.SlaReportDataSummary>> => {
  // Controller method: App\Http\Controllers\Api\RestHooksSamplesController::slaReport
  // URI: api/hooks/samples/slaReport
  return axios.get(route("api.hooks.samples.sla", routeParams), config);
};

export const apiHooksSamplesOverviewSheet = (routeParams?: {[x: string]: unknown}, config?: AxiosRequestConfig): Promise<AxiosResponse<{data: any}>> => {
  // Controller method: App\Http\Controllers\Api\RestHooksSamplesController::overviewSpreadsheetReport
  // URI: api/hooks/samples/overviewSpreadsheetReport
  return axios.get(route("api.hooks.samples.overview-sheet", routeParams), config);
};

export const apiHooksSamplesConversations = (routeParams?: {[x: string]: unknown}, config?: AxiosRequestConfig): Promise<AxiosResponse<{data: any}>> => {
  // Controller method: App\Http\Controllers\Api\RestHooksSamplesController::conversationsSpreadsheetReport
  // URI: api/hooks/samples/conversationsSpreadsheetReport
  return axios.get(route("api.hooks.samples.conversations", routeParams), config);
};

export const apiHooksSamplesMessages = (routeParams?: {[x: string]: unknown}, config?: AxiosRequestConfig): Promise<AxiosResponse<{data: any}>> => {
  // Controller method: App\Http\Controllers\Api\RestHooksSamplesController::messagesSpreadsheetReport
  // URI: api/hooks/samples/messagesSpreadsheetReport
  return axios.get(route("api.hooks.samples.messages", routeParams), config);
};

export const apiHooksSamplesAlerts = (routeParams?: {[x: string]: unknown}, config?: AxiosRequestConfig): Promise<AxiosResponse<{data: any}>> => {
  // Controller method: App\Http\Controllers\Api\RestHooksSamplesController::alerts
  // URI: api/hooks/samples/alerts
  return axios.get(route("api.hooks.samples.alerts", routeParams), config);
};

export const apiNotificationsMarkAsRead = (routeParams?: {[x: string]: unknown}, body?: App.Http.Requests.NotificationMarkAsReadRequest, config?: AxiosRequestConfig): Promise<AxiosResponse<App.DataObjects.TtrSuccessResponse>> => {
  // Controller method: App\Http\Controllers\Api\NotificationsController::markAsRead
  // URI: api/notifications/read
  return axios.post(route("api.notifications.markAsRead", routeParams), body, config);
};

export const apiJoinCompanyRequestResend = (
  routeParams: {company: string | number; [x: string]: unknown},
  body: App.Http.Requests.Auth.JoinCompanyRequestResendRequest,
  config?: AxiosRequestConfig,
): Promise<AxiosResponse<App.DataObjects.TtrStatusResponse>> => {
  // Controller method: App\Http\Controllers\Api\Auth\JoinCompanyRequestController::resend
  // URI: api/join-company-request/resend/{company}
  return axios.post(route("api.join-company-request.resend", routeParams), body, config);
};

export const apiJoinCompanyRequestCancel = (
  routeParams: App.Http.Requests.Auth.JoinCompanyRequestCancelRequest & {company: string | number; [x: string]: unknown},
  config?: AxiosRequestConfig,
): Promise<AxiosResponse<App.DataObjects.TtrStatusResponse>> => {
  // Controller method: App\Http\Controllers\Api\Auth\JoinCompanyRequestController::cancel
  // URI: api/join-company-request/cancel/{company}
  // @ts-ignore the below error is because ziggy does not know about the shape of the query params
  return axios.delete(route("api.join-company-request.cancel", routeParams), config);
};

export const apiJoinCompanyRequestStore = (routeParams?: {[x: string]: unknown}, body?: App.Http.Requests.Auth.JoinCompanyRequestStoreRequest, config?: AxiosRequestConfig): Promise<AxiosResponse<App.DataObjects.TtrStatusResponse>> => {
  // Controller method: App\Http\Controllers\Api\Auth\JoinCompanyRequestController::store
  // URI: api/join-company-request
  return axios.post(route("api.join-company-request.store", routeParams), body, config);
};

export const apiJoinCompanyRequestUpdate = (
  routeParams: {join_company_request: string | number; [x: string]: unknown},
  body: App.Http.Requests.Auth.JoinCompanyRequestUpdateRequest,
  config?: AxiosRequestConfig,
): Promise<AxiosResponse<App.DataObjects.TtrStatusResponse>> => {
  // Controller method: App\Http\Controllers\Api\Auth\JoinCompanyRequestController::update
  // URI: api/join-company-request/{join_company_request}
  return axios.put(route("api.join-company-request.update", routeParams), body, config);
};

export const apiLeadSourcesStore = (routeParams?: {[x: string]: unknown}, body?: App.Http.Requests.Ignite.Tools.LeadSourceRequest, config?: AxiosRequestConfig): Promise<AxiosResponse<App.Models.Ignite.LeadSource>> => {
  // Controller method: App\Http\Controllers\Api\Ignite\Tools\LeadSourcesController::store
  // URI: api/sales/lead-sources
  return axios.post(route("api.lead-sources.store", routeParams), body, config);
};

export const apiLeadSourcesUpdate = (routeParams: {lead_source: string | number; [x: string]: unknown}, body: App.Http.Requests.Ignite.Tools.LeadSourceRequest, config?: AxiosRequestConfig): Promise<AxiosResponse<string>> => {
  // Controller method: App\Http\Controllers\Api\Ignite\Tools\LeadSourcesController::update
  // URI: api/sales/lead-sources/{lead_source}
  return axios.put(route("api.lead-sources.update", routeParams), body, config);
};

export const apiLeadSourcesDestroy = (routeParams: {lead_source: string | number; [x: string]: unknown}, config?: AxiosRequestConfig): Promise<AxiosResponse<App.DataObjects.TtrStatusResponse>> => {
  // Controller method: App\Http\Controllers\Api\Ignite\Tools\LeadSourcesController::destroy
  // URI: api/sales/lead-sources/{lead_source}
  return axios.delete(route("api.lead-sources.destroy", routeParams), config);
};

export const apiDealsIndex = (
  routeParams?: App.Http.Requests.Ignite.Tools.DealsIndexRequest & {[x: string]: unknown},
  config?: AxiosRequestConfig,
): Promise<
  AxiosResponse<{
    data: LaravelLengthAwarePaginator<App.Models.Ignite.Deal>;
    dealStages: Record<number, App.DataObjects.Ignite.DealStageData>;
    filters: {
      date_range: {from: string; to: string} | null;
      date_range_default: {from: string; to: string} | null;
      agent_id: number | null;
      deal_stage: number | null;
      deal_value_from: number | null;
      deal_value_to: number | null;
      search: string;
      pagination: {
        sort_by: "name" | "deal_value" | "created_at" | "closed_at" | "agent_name" | "deal_stage_name";
        direction: "asc" | "desc";
        per_page: number;
        page: number;
      };
      agent?: App.Models.Agent;
    };
  }>
> => {
  // Controller method: App\Http\Controllers\Api\Ignite\Tools\DealsController::index
  // URI: api/sales/deals
  // @ts-ignore the below error is because ziggy does not know about the shape of the query params
  return axios.get(route("api.deals.index", routeParams), config);
};

export const apiDealsStore = (routeParams?: {[x: string]: unknown}, body?: App.Http.Requests.Ignite.Tools.DealRequest, config?: AxiosRequestConfig): Promise<AxiosResponse<string>> => {
  // Controller method: App\Http\Controllers\Api\Ignite\Tools\DealsController::store
  // URI: api/sales/deals
  return axios.post(route("api.deals.store", routeParams), body, config);
};

export const apiDealsUpdate = (routeParams: {deal: string | number; [x: string]: unknown}, body: App.Http.Requests.Ignite.Tools.DealRequest, config?: AxiosRequestConfig): Promise<AxiosResponse<string>> => {
  // Controller method: App\Http\Controllers\Api\Ignite\Tools\DealsController::update
  // URI: api/sales/deals/{deal}
  return axios.put(route("api.deals.update", routeParams), body, config);
};

export const apiDealsDestroy = (routeParams: {deal: string | number; [x: string]: unknown}, config?: AxiosRequestConfig): Promise<AxiosResponse<App.DataObjects.TtrStatusResponse>> => {
  // Controller method: App\Http\Controllers\Api\Ignite\Tools\DealsController::destroy
  // URI: api/sales/deals/{deal}
  return axios.delete(route("api.deals.destroy", routeParams), config);
};

export const apiDealsAddThreads = (routeParams: {deal: string | number; [x: string]: unknown}, body: App.Http.Requests.Ignite.Tools.DealsAddThreadsRequest, config?: AxiosRequestConfig): Promise<AxiosResponse<string>> => {
  // Controller method: App\Http\Controllers\Api\Ignite\Tools\DealsController::addThreads
  // URI: api/sales/deals/{deal}/add-threads
  return axios.patch(route("api.deals.addThreads", routeParams), body, config);
};

export const apiDealStagesIndex = (
  routeParams?: App.Http.Requests.Ignite.Tools.DealStagesIndexRequest & {[x: string]: unknown},
  config?: AxiosRequestConfig,
): Promise<
  AxiosResponse<
    App.DataObjects.TableData & {
      stages: any[];
      closing_count: number;
      not_closing_count: number;
      filters: {search: string | null; closing: boolean | null; sort_by: "display_name" | "probability" | "closing" | "percentage_locked" | "deal_stage_override" | "deals"; sort_direction: "asc" | "desc"};
    }
  >
> => {
  // Controller method: App\Http\Controllers\Api\Ignite\Tools\DealStagesController::index
  // URI: api/sales/deal-stages
  // @ts-ignore the below error is because ziggy does not know about the shape of the query params
  return axios.get(route("api.deal-stages.index", routeParams), config);
};

export const apiDealStagesUpdate = (routeParams: {deal_stage_id: string | number; [x: string]: unknown}, body: App.Http.Requests.Ignite.Tools.DealStageRequest, config?: AxiosRequestConfig): Promise<AxiosResponse<string>> => {
  // Controller method: App\Http\Controllers\Api\Ignite\Tools\DealStagesController::update
  // URI: api/sales/deal-stages/{deal_stage_id}
  return axios.patch(route("api.deal-stages.update", routeParams), body, config);
};

export const apiDealStagesDestroy = (
  routeParams: App.Http.Requests.Ignite.Tools.DealStagesDestroyRequest & {deal_stage_id: string | number; [x: string]: unknown},
  config?: AxiosRequestConfig,
): Promise<AxiosResponse<App.DataObjects.TtrStatusResponse>> => {
  // Controller method: App\Http\Controllers\Api\Ignite\Tools\DealStagesController::destroy
  // URI: api/sales/deal-stages/{deal_stage_id}
  // @ts-ignore the below error is because ziggy does not know about the shape of the query params
  return axios.delete(route("api.deal-stages.destroy", routeParams), config);
};
